const EXTERNAL_LINKS = {
	tickets: "https://www.entrio.hr/event/weblica-2026-25646",
	sessions: "https://sessionize.com/weblica-2026/",
}

const TRACK_BREAK = (duration) => {
	return {
		duration: duration || 10,
		break: true,
		doNotEvaluate: true,
		title: {
			hr: "Pauza za kavu",
			en: "Coffee Break",
		},
		// poweredBy: {
		// 	name: "cWebSpace"
		// }
	}
}

const LUNCH_BREAK = (duration) => {
	return {
		duration: duration || 60,
		break: true,
		lunch: true,
		title: {
			hr: "Ručak",
			en: "Midday Break & Lunch",
		},
		// poweredBy: {
		// 	name: "Full Circle"
		// },
		description: {
			hr: "",
			en: [
				"<p>Take a breather. Grab some lunch from Full Circle, say hi to someone new or visit the partner booths.</p>",
				"<p>No rush - lunch will be available until 15:00.</p>"
			]
		},
	}
}

module.exports = {
	currentYear: 2026,
	dateLimits: {
		ticketSales: {
			weblica: {
				from: null,
				to: "2026-05-08 23:59:59", // this needs to match last ticket sale date
			},
			worklica: {
				from: null,
				to: "2026-05-08 23:59:59", // this needs to match last ticket sale date
			},
		},
		lectureRegistration: {
			from: null,
			to: "2026-02-20 23:59:59",
		},
		workshopRegistration: {
			from: null,
			to: "2026-02-28 23:59:59",
		},
		teamRegistration: {
			from: null,
			to: "2026-04-30 23:59:59",
		},
		sponsorRegistration: {
			from: null,
			to: "2026-03-01 23:59:59",
		},
		exhibitorRegistration: {
			from: null,
			to: null, // "2025-04-30 23:59:59",
		},
		pressRegistration: {
			from: null,
			to: "2026-04-30 23:59:59",
		},
		volunteerRegistration: {
			from: null,
			to: "2026-04-01 23:59:59",
		},
		lastYearSurveyButton: {
			from: null,
			to: "2025-12-31 23:59:59",
		},
		registerToWorkshops: {
			from: null,
			to: "2026-05-08 23:59:59" // by end of event since some may register just in time
		}
	},
	assets: {
		sponsorBrochure: {
			ident: {
				hr: "",
				en: "",
			},
			enabled: false,
		},
		exhibitorBrochure: {
			ident: {
				hr: "",
				en: "",
			},
			enabled: false,
		},
	},
	footerLinks: {
		code: {
			visible: true,
			extra: false,
			url: "/code",
			text: "more.code",
		},
		terms: {
			visible: true,
			extra: false,
			url: "/terms",
			text: "more.terms",
		},
		privacy: {
			visible: true,
			extra: false,
			url: "/privacy",
			text: "more.privacy",
		},
		recording: {
			visible: true,
			extra: false,
			url: "/recording",
			text: "more.recording",
		},
		safety: {
			visible: false,
			extra: true,
			url: "/safety",
			text: "more.safety",
		},
		press: {
			visible: true,
			extra: true,
			url: "/press",
			text: "more.press",
		},
		sponsor: {
			visible: true,
			extra: false,
			url: "/sponsors",
			text: "more.sponsor",
			dateLimit: "sponsorRegistration",
		},
		exhibitor: {
			visible: false,
			extra: false,
			url: "/exhibitors",
			text: "more.exhibitor",
			dateLimit: "exhibitorRegistration",
		},
		volunteer: {
			visible: true,
			extra: false,
			url: "/volunteer",
			text: "more.volunteer",
			dateLimit: "volunteerRegistration",
		}
	},
	events: {
		weblica: {
			// previewMode: ["schedule"],
			// workInProgress: ["speakers", "schedule"],
			tracks: ["mura2", "mura3", "funzone"],
			externalLinks: EXTERNAL_LINKS,
			startDateTime: "2026-05-14 07:50:00",
			endDateTime: "2026-05-14 23:59:59",
			options: {
				entrioEventID: "25646",
			},
			topicsTags: {
				hr: [
					"<b>JavaScript</b>",
					"NodeJS",
					"Bun",
					"React",
					"Vue",
					"Ember",
					"Angular",
					"Svelte",
					"NextJS",
					"Gatsby",
					"NuxtJS",
					"...",
					"<b>PHP</b>",
					"Laravel",
					"Symphony",
					"CakePHP",
					"CodeIgniter",
					"Zend Framework",
					"...",
					"<b>.NET</b>",
					"Azure Cloud Development",
					"Xamarin",
					"Blazor",
					"ML.NET",
					"<b>Python</b>",
					"Flask",
					"Django",
					"CherryPy",
					"Bottle",
					"...",
					"Web",
					"APIs",
					"Services",
					"PWAs",
					"...",
					"<b>Security</b>",
					"OWASP",
					"PenTesting",
					"...",
					"UI",
					"UX",
					"...",
					"Git",
					"Docker",
					"DevOps",
					"Cloud",
					"...",
					"AI",
					"ChatBots",
					"LowCode/NoCode",
					"Blockchain",
					"...",
				],
				en: [
					"<b>JavaScript</b>",
					"NodeJS",
					"Bun",
					"React",
					"Vue",
					"Ember",
					"Angular",
					"Svelte",
					"NextJS",
					"Gatsby",
					"NuxtJS",
					"...",
					"<b>PHP</b>",
					"Laravel",
					"Symphony",
					"CakePHP",
					"CodeIgniter",
					"Zend Framework",
					"...",
					"<b>.NET</b>",
					"Azure Cloud Development",
					"Xamarin",
					"Blazor",
					"ML.NET",
					"<b>Python</b>",
					"Flask",
					"Django",
					"CherryPy",
					"Bottle",
					"...",
					"Web",
					"APIs",
					"Services",
					"PWAs",
					"...",
					"<b>Security</b>",
					"OWASP",
					"PenTesting",
					"...",
					"UI",
					"UX",
					"...",
					"Git",
					"Docker",
					"DevOps",
					"Cloud",
					"...",
					"AI",
					"ChatBots",
					"LowCode/NoCode",
					"Blockchain",
					"...",
				],
			},
			menuItems: {
				about: {
					url: "/weblica#about",
					visible: false,
				},
				news: {
					url: "/weblica#news",
					visible: false,
				},
				speakers: {
					url: "/weblica#speakers",
					visible: true,
				},
				schedule: {
					url: "/weblica#schedule",
					visible: true,
				},
				venue: {
					url: "/weblica#venue",
					visible: "active,before", // true || false || "active,before,after" (status dependant)
				},
				faq: {
					url: "/weblica#faq",
					visible: "active,before",
				},
				sponsors: {
					url: "/weblica#sponsors",
					visible: true,
				},
				tickets: {
					url: "/weblica#tickets",
					visible: false,
				},
				testimonials: {
					url: "/weblica#testimonials",
					visible: false,
				},
			},
			buttons: {
				lecture: {
					title: "Call for Speakers",
					url: EXTERNAL_LINKS.sessions,
					hollow: true,
					external: true,
					visible: false,
					visibleOnHero: true,
					wide: true,
					// full: true,
					dateLimit: "lectureRegistration",
				},
				tickets: {
					title: "Get Tickets",
					url: "/weblica#tickets",
					hollow: false,
					external: false,
					visible: true, // XXX - true,
					dateLimit: "ticketSales.weblica",
					//---
					visibleOnHero: true, // XXX - true,
					hollowOnHero: true,
					extraClassesOnHero: ["showOnSmall"],
					//---
					floatingSpecial: {
						// if defined, it will override given when on floating menu - this jumps directly to Entrio instead of to #tickets section
						url: EXTERNAL_LINKS.tickets,
						external: true,
					},
				},
			},
			forcedButtons: {
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: true,
					linkInFooter: true,
					dateLimit: "sponsorRegistration",
				},
				exhibitor: {
					title: "Become an Exhibitor",
					url: "/exhibitors",
					hollow: true,
					external: false,
					visible: false,
					linkInFooter: false,
					dateLimit: "exhibitorRegistration",
				},
				volunteer: {
					title: "Become a Volunteer",
					url: "/volunteer",
					hollow: true,
					external: false,
					visible: false,
					linkInFooter: true,
					dateLimit: "volunteerRegistration",
				},
			},
			sections: {
				hero: {
					visible: true,
					bgImage: "/media/WEBLICA_banner_1920x1080.png",
					introImage: {
						img: "Weblica 2025 (33).jpg",
						// img: "Weblica 2025 (40).jpg",
						alt: "Hero Image",
					},
					// introImageRandom: [
					// 	{
					// 		img: "WEBLICA_banner_1280x720.png",
					// 		alt: "Worklica 2025",
					// 	},
					// 	{
					// 		img: "Weblica 2025 (175).jpg",
					// 		alt: "Weblica 2025",
					// 	},
					// 	{
					// 		img: "Weblica 2025 (12).jpg",
					// 		alt: "Weblica 2025",
					// 	},
					// 	{
					// 		img: "Weblica 2025 (147).jpg",
					// 		alt: "Weblica 2025",
					// 	},
					// 	{
					// 		img: "Weblica 2025 (33).jpg",
					// 		alt: "Weblica 2025",
					// 	},
					// 	{
					// 		img: "Weblica 2025 (209).jpg",
					// 		alt: "Weblica 2025",
					// 	},
					// 	{
					// 		img: "Weblica 2025 (294).jpg",
					// 		alt: "Weblica 2025",
					// 	},
					// 	{
					// 		img: "Weblica 2025 (239).jpg",
					// 		alt: "Weblica 2025",
					// 	},
					// ],
					// introGallery: [
					// 	{
					// 		img: "Weblica 2025 (12).jpg",
					// 		alt: "Weblica 2025",
					// 	},
					// 	{
					// 		img: "Weblica 2025 (147).jpg",
					// 		alt: "Weblica 2025",
					// 	},
					// 	{
					// 		img: "Weblica 2025 (33).jpg",
					// 		alt: "Weblica 2025",
					// 	},
					// 	{
					// 		img: "Weblica 2025 (209).jpg",
					// 		alt: "Weblica 2025",
					// 	},
					// ],
					// introVideo: [
					// 	{
					// 		media: "(max-width: 640px)",
					// 		url: "/media/WEBLICA_banner_animation_640x360.mp4",
					// 		poster: "/media/WEBLICA_banner_1280x720.png",
					// 		type: "video/mp4",
					// 	},
					// 	{
					// 		media: "(max-width: 1280px)",
					// 		url: "/media/WEBLICA_banner_animation_1280x720.mp4",
					// 		poster: "/media/WEBLICA_banner_1280x720.png",
					// 		type: "video/mp4",
					// 	},
					// 	{
					// 		media: "(min-width: 1281px)",
					// 		url: "/media/WEBLICA_banner_animation_1920x1080.mp4",
					// 		poster: "/media/WEBLICA_banner_1920x1080.png",
					// 		type: "video/mp4",
					// 	},
					// ],
					blocks: [],
				},
				about: {
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "Weblica 2025 (2).jpg",
								alt: "Weblica 2025",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
						{
							width: "half",
							text: "txt_bbb",
						},
						{
							width: "half",
							image: {
								file: "Weblica 2025 (17).jpg",
								alt: "Weblica 2025",
							},
						},
						{
							width: "half",
							gallery: [
								{
									img: "Weblica 2025 (38).jpg",
									alt: "Weblica 2025",
								},
								{
									img: "Weblica 2025 (127).jpg",
									alt: "Weblica 2025",
								},
								{
									img: "Weblica 2025 (163).jpg",
									alt: "Weblica 2025",
								},
								{
									img: "Weblica 2025 (152).jpg",
									alt: "Weblica 2025",
								},
							],
						},
						{
							width: "half",
							text: "txt_ccc",
						},
					],
				},
				news: {
					visible: false,
				},
				speakers: {
					visible: true,
				},
				schedule: {
					visible: true,
				},
				venue: {
					visible: true,
				},
				tickets: {
					visible: true,
				},
				faq: {
					visible: true,
				},
				testimonials: {
					visible: true,
				},
				historyGallery: {
					visible: true,
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
			},
			venue: {
				venue: "terme-sveti-martin",
			},
			tickets: [],
			sessions: [
				{
					"visible": true,
					"placeholder": false,
					"ident": "deploy-without-drama-a-legal-framework-for-tech-teams",
					"duration": 45,
					"type": "talk",
					"language": "hr",
					"level": "intermediate",
					"code": "none",
					"originalContentLanguage": "en",
					"title": {
						"hr": "Deploy Without Drama: A Legal Framework for Tech Teams",
						"en": "Deploy Without Drama: A Legal Framework for Tech Teams"
					},
					"description": {
						"hr": "Every digital product follows a lifecycle - from idea and development to production and scaling. At each stage, legal risks emerge that tech teams often recognize too late. What does the EU AI Act mean for your AI-powered feature? Who is actually liable when your cloud provider suffers a breach? How do data protection rules shape your DevOps pipeline? And why are the NIS2 Directive and the Cyber Resilience Act - which applies to virtually every developer shipping digital products - no longer just a problem for \"regulated industries\"? Two lawyers walk you through three key regulatory layers - artificial intelligence, cloud computing, and data security & privacy - across the full stack, from your codebase to your cloud infrastructure. No legalese, real-world examples, and a practical checklist you can apply the moment you get back to your desk.",
						"en": "Every digital product follows a lifecycle - from idea and development to production and scaling. At each stage, legal risks emerge that tech teams often recognize too late. What does the EU AI Act mean for your AI-powered feature? Who is actually liable when your cloud provider suffers a breach? How do data protection rules shape your DevOps pipeline? And why are the NIS2 Directive and the Cyber Resilience Act - which applies to virtually every developer shipping digital products - no longer just a problem for \"regulated industries\"? Two lawyers walk you through three key regulatory layers - artificial intelligence, cloud computing, and data security & privacy - across the full stack, from your codebase to your cloud infrastructure. No legalese, real-world examples, and a practical checklist you can apply the moment you get back to your desk."
					},
					"speakers": [
						"porobija-marko",
						"duric-marko"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "cloud-native-smart-transport-architecture-security-dev-lessons",
					"duration": 45,
					"type": "talk",
					"language": "hr",
					"level": "intermediate",
					"code": "light",
					"originalContentLanguage": "en",
					"title": {
						"hr": "Cloud-Native Smart Transport: Architecture, Security & Dev Lessons",
						"en": "Cloud-Native Smart Transport: Architecture, Security & Dev Lessons"
					},
					"description": {
						"hr": "What does it really take to build a secure cloud-native SaaS platform for smart transport? In this talk, we’ll share our real-world experience designing and running a Kubernetes-based platform with security as a first-class concern. We’ll cover key architectural decisions, common pitfalls, and practical security challenges — from protecting services and data to maintaining resilience at scale. Expect honest lessons learned from production, what worked, what didn’t, and actionable insights for engineers building modern, security-focused SaaS platforms.",
						"en": "What does it really take to build a secure cloud-native SaaS platform for smart transport? In this talk, we’ll share our real-world experience designing and running a Kubernetes-based platform with security as a first-class concern. We’ll cover key architectural decisions, common pitfalls, and practical security challenges — from protecting services and data to maintaining resilience at scale. Expect honest lessons learned from production, what worked, what didn’t, and actionable insights for engineers building modern, security-focused SaaS platforms."
					},
					"speakers": [
						"adanic-alen"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "from-vibes-to-production-deploying-ai-built-apps",
					"duration": 45,
					"type": "talk",
					"language": "en",
					"level": "intermediate",
					"code": "light",
					"originalContentLanguage": "en",
					"title": {
						"hr": "From Vibes to Production: Deploying AI-Built Apps",
						"en": "From Vibes to Production: Deploying AI-Built Apps"
					},
					"description": {
						"hr": "Last year, we explored how “vibe programming” enables developers to build applications using natural-language prompts instead of code. This year, we take it a step further: can those AI-generated applications actually be deployed to production?\r\n\r\nIn this session, I’ll share practical lessons from real-world projects where vibe-coded apps moved beyond prototypes and into live environments. Together we’ll look at:\r\n\t•\tA live demo of taking an AI-generated app from prompt to deployment\r\n\t•\tProven workflows for refining, testing, and securing AI-written code\r\n\t•\tCommon pitfalls (and how to avoid them) when moving from demo to production\r\n\t•\tHow to blend AI speed with human oversight for reliability at scale\r\n\r\nBy the end of the session, you’ll see how vibe programming isn’t just for rapid prototyping—it can also deliver production-ready applications, faster than ever before.",
						"en": "Last year, we explored how “vibe programming” enables developers to build applications using natural-language prompts instead of code. This year, we take it a step further: can those AI-generated applications actually be deployed to production?\r\n\r\nIn this session, I’ll share practical lessons from real-world projects where vibe-coded apps moved beyond prototypes and into live environments. Together we’ll look at:\r\n\t•\tA live demo of taking an AI-generated app from prompt to deployment\r\n\t•\tProven workflows for refining, testing, and securing AI-written code\r\n\t•\tCommon pitfalls (and how to avoid them) when moving from demo to production\r\n\t•\tHow to blend AI speed with human oversight for reliability at scale\r\n\r\nBy the end of the session, you’ll see how vibe programming isn’t just for rapid prototyping—it can also deliver production-ready applications, faster than ever before."
					},
					"speakers": [
						"breznjak-nikola"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "trikovi-koristi-i-tranzicije-kako-lideri-i-zaposlenici-percipiraju-umjetnu-inteligenciju-ui",
					"duration": 45,
					"type": "talk",
					"language": "hr",
					"level": "intermediate",
					"code": "none",
					"originalContentLanguage": "hr",
					"title": {
						"hr": "Trikovi, koristi i tranzicije: kako lideri i zaposlenici percipiraju umjetnu inteligenciju (UI)",
						"en": "Trikovi, koristi i tranzicije: kako lideri i zaposlenici percipiraju umjetnu inteligenciju (UI)"
					},
					"description": {
						"hr": "UI asistenti/CoPilot-i pružaju koristi radnicima - automatiziraju repetitivne zadatke, izdvajaju uvide i povećavaju individualnu produktivnost - a istovremeno se suočavaju s \"trikovima\" koje UI izvodi, poput pristranosti, halucinacija i problema s povjerenjem.\r\nMeđutim, pojavila se ključna razlika u percepciji: zaposlenici intenzivno eksperimentiraju s umjetnom inteligencijom, dok mnogi lideri zaostaju u strateškom prihvaćanju umjetne inteligencije, podcjenjujući njezin potencijal i ne uspijevajući skalirati pilot projekte u značajne promjene unutar tvrtke. \r\nPridružite nam se u raspravi o tome što je potrebno da vodstvo od opreznog promatrača postane kompetentni praktičar – usklađujući primjenu umjetne inteligencije s poslovnim ciljevima, ulažući u razvoj vještina i uspostavljajući učinkovito upravljanje sve s ciljem omogućavanja tranzicije koja će premostiti taj jaz i u potpunosti osloboditi potencijal cijele organizacije!",
						"en": "UI asistenti/CoPilot-i pružaju koristi radnicima - automatiziraju repetitivne zadatke, izdvajaju uvide i povećavaju individualnu produktivnost - a istovremeno se suočavaju s \"trikovima\" koje UI izvodi, poput pristranosti, halucinacija i problema s povjerenjem.\r\nMeđutim, pojavila se ključna razlika u percepciji: zaposlenici intenzivno eksperimentiraju s umjetnom inteligencijom, dok mnogi lideri zaostaju u strateškom prihvaćanju umjetne inteligencije, podcjenjujući njezin potencijal i ne uspijevajući skalirati pilot projekte u značajne promjene unutar tvrtke. \r\nPridružite nam se u raspravi o tome što je potrebno da vodstvo od opreznog promatrača postane kompetentni praktičar – usklađujući primjenu umjetne inteligencije s poslovnim ciljevima, ulažući u razvoj vještina i uspostavljajući učinkovito upravljanje sve s ciljem omogućavanja tranzicije koja će premostiti taj jaz i u potpunosti osloboditi potencijal cijele organizacije!"
					},
					"speakers": [
						"bronzin-tomislav"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "jedna-cipela-za-24000-nogu-kako-dizajnirati-interni-enterprise-softver-koji-nikog-ne-zulja",
					"duration": 45,
					"type": "talk",
					"language": "hr",
					"level": "intermediate",
					"code": "none",
					"originalContentLanguage": "hr",
					"title": {
						"hr": "Jedna cipela za 24.000 nogu - Kako dizajnirati interni enterprise softver koji nikog „ne žulja“",
						"en": "Jedna cipela za 24.000 nogu - Kako dizajnirati interni enterprise softver koji nikog „ne žulja“ "
					},
					"description": {
						"hr": "Kako dizajnirati softver koji koristi tisuće ljudi s različitim razinama digitalne pismenosti, a s istim osnovnim zadacima - od rješavanja IT problema do upravljanja resursima?\r\n\r\nGovorit ću o tome kako smo dizajnirali i razvili interni self-service portal. Cilj je bio omogućiti svakom od preko 12.000 zaposlenika globalne korporacije da samostalno rješava zahtjeve koji su se ranije čekali tjednima, mjesecima - ili nikad nisu bili riješeni.\r\n\r\nPokazat ću kako smo postigli ravnotežu između jednostavnosti korištenja za ne-tehničke korisnike i snage funkcionalnosti za napredne. Radilo se o složenom sustavu koji se oslanjao na više naslijeđenih alata i izvora podataka - često neurednih, nepouzdanih ili međusobno neusklađenih.\r\n\r\nOvo je priča o UX dizajnu u stvarnim uvjetima gdje ne postoji rješenje koje savršeno odgovara svima, ali se može postići ravnoteža koja pokriva ono što je većini zaista važno. Cilj je bio stvoriti sustav koji je pouzdan, jasan i dovoljno jednostavan da se koristi bez frustracije - bez nepotrebnih „žuljeva“.",
						"en": "Kako dizajnirati softver koji koristi tisuće ljudi s različitim razinama digitalne pismenosti, a s istim osnovnim zadacima - od rješavanja IT problema do upravljanja resursima?\r\n\r\nGovorit ću o tome kako smo dizajnirali i razvili interni self-service portal. Cilj je bio omogućiti svakom od preko 12.000 zaposlenika globalne korporacije da samostalno rješava zahtjeve koji su se ranije čekali tjednima, mjesecima - ili nikad nisu bili riješeni.\r\n\r\nPokazat ću kako smo postigli ravnotežu između jednostavnosti korištenja za ne-tehničke korisnike i snage funkcionalnosti za napredne. Radilo se o složenom sustavu koji se oslanjao na više naslijeđenih alata i izvora podataka - često neurednih, nepouzdanih ili međusobno neusklađenih.\r\n\r\nOvo je priča o UX dizajnu u stvarnim uvjetima gdje ne postoji rješenje koje savršeno odgovara svima, ali se može postići ravnoteža koja pokriva ono što je većini zaista važno. Cilj je bio stvoriti sustav koji je pouzdan, jasan i dovoljno jednostavan da se koristi bez frustracije - bez nepotrebnih „žuljeva“."
					},
					"speakers": [
						"cindric-gordon"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "vise-ai-a-manje-tokena-optimiranjem-arhitekture-do-manjih-troskova",
					"duration": 45,
					"type": "talk",
					"language": "hr",
					"level": "expert",
					"code": "none",
					"originalContentLanguage": "hr",
					"title": {
						"hr": "Više AI-a, manje tokena: Optimiranjem arhitekture do manjih troškova",
						"en": "Više AI-a, manje tokena: Optimiranjem arhitekture do manjih troškova"
					},
					"description": {
						"hr": "Potrošnja AI tokena raste eksponencijalno. Agentski procesi, integracije konteksta i korištenje AI API-ja po radniku se umnožavaju stopama koje će današnje AI budžete učiniti zanemarivim za dvije ili tri godine. U međuvremenu, proizvodnja čipova, dostupnost memorije i GPU-ova skaliraju linearno u najboljem slučaju —  a za izgradnju fabrika treba minimalno četiri godine, kapaciteti HBM-a (High Bandwidth Memory DDR5) su rezervisani od strane velikih igrača do 2028., a cijene memorije bi trebale porasti preko 50% do 2027.\r\nVećina timova reaguje prebacivanjem na jeftinije modele ili skraćivanjem promptova. To je privremeno rješenje. Strukturalni odgovor je arhitekturalni: prestani obrađivati tokene koji ti uopće ne trebaju.\r\n\r\nOva prezentacija predstavlja višeslojnu, potpuno lokalnu RAG arhitekturu dizajniranu oko jednog principa — svaka komponenta u pipelineu postoji da smanji ono što LLM mora obraditi, dok poboljšava kvalitet onoga što zapravo vidi. Proći ćemo kroz produkcijski Data Warehouse sistem koji radi potpuno lokalno sa open-source modelima: od obogaćivanja podataka u vrijeme unosa tako da pretraga bolje funkcioniše kasnije, do slojevitih strategija pretrage koje hirurški biraju kontekst iz stotina mogućih izvora. Pokriti ćemo kako rastaviti kompleksna pitanja prije nego što pogode sloj pretrage, kako usmjeravati različite zadatke na različito dimenzionirane modele umjesto da se sve šalje na najveći.\r\nUsput ćemo se osvrnuti i na druga ograničenje koje se krije iza problema troškova: privatnost. Za regulirane industrije pod GDPR-om i EU AI Aktom, slanje internih podataka na eksterne API-je nije opcija. Dobro izgrađen lokalni RAG sistem rješava oba problema istovremeno — manje tokena i potpuna suverenost nad podacima\r\n\r\nDobro izgrađen lokalni RAG sistem rješava oba problema istovremeno — smanjuje broj tokena koje LLM mora obraditi, i osigurava potpunu suverenost nad podacima. Umjesto da jurimo za jeftinijim modelima ili kraćim promptovima, pravi odgovor leži u arhitekturi koja eliminira nepotreban rad prije nego što uopće dođe do modela.",
						"en": "Potrošnja AI tokena raste eksponencijalno. Agentski procesi, integracije konteksta i korištenje AI API-ja po radniku se umnožavaju stopama koje će današnje AI budžete učiniti zanemarivim za dvije ili tri godine. U međuvremenu, proizvodnja čipova, dostupnost memorije i GPU-ova skaliraju linearno u najboljem slučaju —  a za izgradnju fabrika treba minimalno četiri godine, kapaciteti HBM-a (High Bandwidth Memory DDR5) su rezervisani od strane velikih igrača do 2028., a cijene memorije bi trebale porasti preko 50% do 2027.\r\nVećina timova reaguje prebacivanjem na jeftinije modele ili skraćivanjem promptova. To je privremeno rješenje. Strukturalni odgovor je arhitekturalni: prestani obrađivati tokene koji ti uopće ne trebaju.\r\n\r\nOva prezentacija predstavlja višeslojnu, potpuno lokalnu RAG arhitekturu dizajniranu oko jednog principa — svaka komponenta u pipelineu postoji da smanji ono što LLM mora obraditi, dok poboljšava kvalitet onoga što zapravo vidi. Proći ćemo kroz produkcijski Data Warehouse sistem koji radi potpuno lokalno sa open-source modelima: od obogaćivanja podataka u vrijeme unosa tako da pretraga bolje funkcioniše kasnije, do slojevitih strategija pretrage koje hirurški biraju kontekst iz stotina mogućih izvora. Pokriti ćemo kako rastaviti kompleksna pitanja prije nego što pogode sloj pretrage, kako usmjeravati različite zadatke na različito dimenzionirane modele umjesto da se sve šalje na najveći.\r\nUsput ćemo se osvrnuti i na druga ograničenje koje se krije iza problema troškova: privatnost. Za regulirane industrije pod GDPR-om i EU AI Aktom, slanje internih podataka na eksterne API-je nije opcija. Dobro izgrađen lokalni RAG sistem rješava oba problema istovremeno — manje tokena i potpuna suverenost nad podacima\r\n\r\nDobro izgrađen lokalni RAG sistem rješava oba problema istovremeno — smanjuje broj tokena koje LLM mora obraditi, i osigurava potpunu suverenost nad podacima. Umjesto da jurimo za jeftinijim modelima ili kraćim promptovima, pravi odgovor leži u arhitekturi koja eliminira nepotreban rad prije nego što uopće dođe do modela."
					},
					"speakers": [
						"drljevic-omar"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "agentic-ai-a-new-software-development-paradigm",
					"duration": 45,
					"type": "talk",
					"language": "en",
					"level": "intermediate",
					"code": "light",
					"originalContentLanguage": "en",
					"title": {
						"hr": "Agentic AI - A New Software Development Paradigm",
						"en": "Agentic AI - A New Software Development Paradigm"
					},
					"description": {
						"hr": "This presentation explores why Agentic AI is fundamentally restructuring software engineering. We begin by clarifying the \"intelligence gap\"—distinguishing between the reactive nature of LLMs and the autonomous, goal-oriented nature of Agentic systems.\r\n\r\nMoving beyond theory, we’ll analyze how this paradigm is being operationalized within Big Tech. Is the shift toward \"Agent-First\" development a genuine evolution of the SDLC or just another high-cost hype cycle? We’ll examine the transition from writing code to Mechanism Engineering, where developers orchestrate fleets of agents to solve complex, multi-step problems. Whether you view it as a threat or a tool, the move from \"AI-assisted\" to \"AI-autonomous\" is no longer optional; we will conclude by determining if this shift will stand the test of time or buckle under the weight of enterprise reality.",
						"en": "This presentation explores why Agentic AI is fundamentally restructuring software engineering. We begin by clarifying the \"intelligence gap\"—distinguishing between the reactive nature of LLMs and the autonomous, goal-oriented nature of Agentic systems.\r\n\r\nMoving beyond theory, we’ll analyze how this paradigm is being operationalized within Big Tech. Is the shift toward \"Agent-First\" development a genuine evolution of the SDLC or just another high-cost hype cycle? We’ll examine the transition from writing code to Mechanism Engineering, where developers orchestrate fleets of agents to solve complex, multi-step problems. Whether you view it as a threat or a tool, the move from \"AI-assisted\" to \"AI-autonomous\" is no longer optional; we will conclude by determining if this shift will stand the test of time or buckle under the weight of enterprise reality."
					},
					"speakers": [
						"duranec-erik"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "solution-architecture-in-the-ai-era",
					"duration": 45,
					"type": "talk",
					"language": "hr",
					"level": "intermediate",
					"code": "light",
					"originalContentLanguage": "en",
					"title": {
						"hr": "Solution Architecture in the AI era",
						"en": "Solution Architecture in the AI era"
					},
					"description": {
						"hr": "How could AI affect solutions?  Solutions have AI in them and are not \"fixed\" but adapt now! How should Solution Architecture for these new types of solutions look like? Also we are talking about architecture as code. Of course the next question is can agents “vibe” Solution Architecture? It is code now, no?\r\nAll these questions started from a LinkedIn article, so let’s go together on what it says, and see what we have now and what can wait us in the immediate to distant future. And some ideas on how to use AI to get us a nicer Solutions Architecture, from documentation to diagrams. Last but not least, how can Copilot help us create a Solution Architecture ? Yes it can also that...\r\n\r\nKako bi umjetna inteligencija mogla utjecati na rješenja? Rješenja sadrže umjetnu inteligenciju i nisu \"fiksna\", već se sada prilagođavaju po zadatku! Kako bi trebala izgledati Solution Architecture za ove nove vrste rješenja? Također, govorimo o arhitekturi kao kodu. Naravno, sljedeće pitanje je mogu li agenti \"Vibe\" Solution Architecture? To je sada kod, zar ne?\r\nSva ova pitanja započela su iz članka na LinkedInu, pa idemo zajedno na ono što piše i vidimo što imamo sada, a što nas može čekati u neposrednoj ili dalekoj budućnosti. I neke ideje o tome kako koristiti umjetnu inteligenciju kako bismo dobili ljepšu Solution Architecture, od dokumentacije do dijagrama. Na kraju, ali ne i najmanje važno, kako nam Copilot može pomoći u stvaranju Solution Architecture?  Da, može cak i to....\r\n",
						"en": "How could AI affect solutions?  Solutions have AI in them and are not \"fixed\" but adapt now! How should Solution Architecture for these new types of solutions look like? Also we are talking about architecture as code. Of course the next question is can agents “vibe” Solution Architecture? It is code now, no?\r\nAll these questions started from a LinkedIn article, so let’s go together on what it says, and see what we have now and what can wait us in the immediate to distant future. And some ideas on how to use AI to get us a nicer Solutions Architecture, from documentation to diagrams. Last but not least, how can Copilot help us create a Solution Architecture ? Yes it can also that...\r\n\r\nKako bi umjetna inteligencija mogla utjecati na rješenja? Rješenja sadrže umjetnu inteligenciju i nisu \"fiksna\", već se sada prilagođavaju po zadatku! Kako bi trebala izgledati Solution Architecture za ove nove vrste rješenja? Također, govorimo o arhitekturi kao kodu. Naravno, sljedeće pitanje je mogu li agenti \"Vibe\" Solution Architecture? To je sada kod, zar ne?\r\nSva ova pitanja započela su iz članka na LinkedInu, pa idemo zajedno na ono što piše i vidimo što imamo sada, a što nas može čekati u neposrednoj ili dalekoj budućnosti. I neke ideje o tome kako koristiti umjetnu inteligenciju kako bismo dobili ljepšu Solution Architecture, od dokumentacije do dijagrama. Na kraju, ali ne i najmanje važno, kako nam Copilot može pomoći u stvaranju Solution Architecture?  Da, može cak i to....\r\n"
					},
					"speakers": [
						"gheorghiu-catalin"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "going-by-the-book-and-failing",
					"duration": 45,
					"type": "talk",
					"language": "en",
					"level": "intermediate",
					"code": "none",
					"originalContentLanguage": "en",
					"title": {
						"hr": "Going by the book and failing",
						"en": "Going by the book and failing"
					},
					"description": {
						"hr": "How do you support the exponential growth of your product without the exponential growth of your teams? \r\n  \r\nPortfolio management, Wardley mapping, and Domain-Driven Design are effective ways to “do more with the same” in fast-growing organizations, but going by the book won’t guarantee the intended outcome. \r\n\r\nJoin this session to learn why you need 9 allies, as well as many other things, to introduce these ideas in fast-growing organizations.\r\n\r\n#WardleyMapping #DomainDrivenDesign #PortfolioManagement #Strategy",
						"en": "How do you support the exponential growth of your product without the exponential growth of your teams? \r\n  \r\nPortfolio management, Wardley mapping, and Domain-Driven Design are effective ways to “do more with the same” in fast-growing organizations, but going by the book won’t guarantee the intended outcome. \r\n\r\nJoin this session to learn why you need 9 allies, as well as many other things, to introduce these ideas in fast-growing organizations.\r\n\r\n#WardleyMapping #DomainDrivenDesign #PortfolioManagement #Strategy"
					},
					"speakers": [
						"huizendveld-marijn"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "net-iot-and-hedgehogs",
					"duration": 45,
					"type": "talk",
					"language": "en",
					"level": "intermediate",
					"code": "light",
					"originalContentLanguage": "en",
					"title": {
						"hr": ".NET, IoT and Hedgehogs!",
						"en": ".NET, IoT and Hedgehogs!"
					},
					"description": {
						"hr": "Using C# / .NET Technologies and IoT to curate and automate video footage of garden hedgehogs.\r\n\r\nAn experimental journey through hardware device access, cloud storage, serverless functions, and a public website.\r\n\r\nWith an insight into problem-solving changes necessary to bring the code cross-platform to run on Linux on a Raspberry Pi.\r\n\r\nAn inspiring talk about how a completely unplanned event led to several fluid and experimental systems being developed, hacked together, and evolved in a unique way.",
						"en": "Using C# / .NET Technologies and IoT to curate and automate video footage of garden hedgehogs.\r\n\r\nAn experimental journey through hardware device access, cloud storage, serverless functions, and a public website.\r\n\r\nWith an insight into problem-solving changes necessary to bring the code cross-platform to run on Linux on a Raspberry Pi.\r\n\r\nAn inspiring talk about how a completely unplanned event led to several fluid and experimental systems being developed, hacked together, and evolved in a unique way."
					},
					"speakers": [
						"irving-mike"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"keynote": true,
					"ident": "keynote-predavanje",
					"duration": 45,
					"type": "talk",
					"language": "hr",
					"level": "novice",
					"code": "none",
					"originalContentLanguage": "en",
					"title": {
						"hr": "What AI Knows, What It Doesn't, and What It Never Will",
						"en": "What AI Knows, What It Doesn't, and What It Never Will"
					},
					"description": {
						"hr": [
							"<p>AI today writes code, generates images, holds conversations, and makes decisions but how much does it truly understand? In this keynote, Dr. Karlo Knežević offers a snapshot of the current state of AI: from frontier models and agents to capabilities that sounded like science fiction just yesterday.</p>",
							"<p>But beyond the possibilities, we'll look at the other side of the coin: the fundamental limitations imposed by mathematics and theoretical computer science, the ethical questions growing louder by the day, and the thin line between what AI can automate and what remains inherently human. Finally, Karlo shares lessons from Sofascore: how AI was adopted across the entire company and what they learned along the way.</p>"
						],
						"en": [
							"<p>AI today writes code, generates images, holds conversations, and makes decisions but how much does it truly understand? In this keynote, Dr. Karlo Knežević offers a snapshot of the current state of AI: from frontier models and agents to capabilities that sounded like science fiction just yesterday.</p>",
							"<p>But beyond the possibilities, we'll look at the other side of the coin: the fundamental limitations imposed by mathematics and theoretical computer science, the ethical questions growing louder by the day, and the thin line between what AI can automate and what remains inherently human. Finally, Karlo shares lessons from Sofascore: how AI was adopted across the entire company and what they learned along the way.</p>"
						]
					},
					"speakers": [
						"knezevic-karlo"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "reinforcement-learning-prednosti-i-primjena-ove-grane-ai",
					"duration": 45,
					"type": "talk",
					"language": "hr",
					"level": "novice",
					"code": "none",
					"originalContentLanguage": "en",
					"title": {
						"hr": "Reinforcement Learning – prednosti i primjena ove grane AI",
						"en": "Reinforcement Learning – prednosti i primjena ove grane AI"
					},
					"description": {
						"hr": "Metoda učenja u kojoj AI uči mehanizmom nagrade i kazne naziva se reinforcement learning, a u praksi postiže izvrsne rezultate u kompleksnim područjima primjene. Ova grana strojnog učenja ima cijeli niz prednosti, a na raspolaganju imamo više modernih framework-a za reinforcement learning. Upoznati ćemo algoritme poput Q-learning, Deep Q-networks i drugih, te vidjeti kako ih možemo grupirati. Područja korištenje reinforcement learning uključuju robotiku, AI u igrama, marketing, upravljanje resursima itd. Primjer korištenja je i AlphaGo, prvi programa koji je pobijedio profesionalnog igrača strateške društvene igre Go, a radi se o igri koja je teža (za AI) nego šah.",
						"en": "Metoda učenja u kojoj AI uči mehanizmom nagrade i kazne naziva se reinforcement learning, a u praksi postiže izvrsne rezultate u kompleksnim područjima primjene. Ova grana strojnog učenja ima cijeli niz prednosti, a na raspolaganju imamo više modernih framework-a za reinforcement learning. Upoznati ćemo algoritme poput Q-learning, Deep Q-networks i drugih, te vidjeti kako ih možemo grupirati. Područja korištenje reinforcement learning uključuju robotiku, AI u igrama, marketing, upravljanje resursima itd. Primjer korištenja je i AlphaGo, prvi programa koji je pobijedio profesionalnog igrača strateške društvene igre Go, a radi se o igri koja je teža (za AI) nego šah."
					},
					"speakers": [
						"lohert-marko"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "aiot-kada-inteligencija-dolazi-na-rub-mreze",
					"duration": 45,
					"type": "talk",
					"language": "hr",
					"level": "intermediate",
					"code": "none",
					"originalContentLanguage": "hr",
					"title": {
						"hr": "AIoT: Kada inteligencija dolazi na rub mreže",
						"en": "AIoT: Kada inteligencija dolazi na rub mreže"
					},
					"description": {
						"hr": "Što se događa kada se umjetna inteligencija spusti iz clouda i preseli izravno na umrežene uređaje? Nastaje AIoT – nova generacija pametnih sustava koji uče, analiziraju i donose odluke u stvarnom vremenu.\r\nNa ovom predavanju ulazimo u svijet inteligentno povezanih uređaja koji pokreću pametne gradove, autonomne sustave i digitalnu transformaciju industrije. Kroz konkretne primjere, stvarne scenarije i tehnološke uvide pokazat ćemo kako AIoT briše granicu između softvera i fizičkog svijeta — i zašto je upravo sada pravi trenutak da budete dio te tehnološke evolucije.",
						"en": "Što se događa kada se umjetna inteligencija spusti iz clouda i preseli izravno na umrežene uređaje? Nastaje AIoT – nova generacija pametnih sustava koji uče, analiziraju i donose odluke u stvarnom vremenu.\r\nNa ovom predavanju ulazimo u svijet inteligentno povezanih uređaja koji pokreću pametne gradove, autonomne sustave i digitalnu transformaciju industrije. Kroz konkretne primjere, stvarne scenarije i tehnološke uvide pokazat ćemo kako AIoT briše granicu između softvera i fizičkog svijeta — i zašto je upravo sada pravi trenutak da budete dio te tehnološke evolucije."
					},
					"speakers": [
						"matosa-igor"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "from-atoms-to-units-rethinking-what-we-test",
					"duration": 45,
					"type": "talk",
					"language": "en",
					"level": "intermediate",
					"code": "light",
					"originalContentLanguage": "en",
					"title": {
						"hr": "From Atoms to Units: Rethinking What We Test",
						"en": "From Atoms to Units: Rethinking What We Test"
					},
					"description": {
						"hr": "We once believed atoms were indivisible — until we learned they weren’t. Unit testing has followed a similar path. For years, we’ve treated “unit” as something small and sacred — a single class, a method, a function. But in real systems, that tidy definition often doesn’t hold up.\r\n\r\nThis talk is about what happens when the textbook rules meet messy, real-world code. We’ll rethink what a “unit” really is, explore better ways to test meaningful behavior, and question some long-standing assumptions. Along the way, we’ll take a peek at how AI might help us write better tests — or at least ask better questions.\r\n\r\nIf you’ve ever wondered why your tests don’t quite match the way your code actually works, you’re not alone. Let’s talk about it.",
						"en": "We once believed atoms were indivisible — until we learned they weren’t. Unit testing has followed a similar path. For years, we’ve treated “unit” as something small and sacred — a single class, a method, a function. But in real systems, that tidy definition often doesn’t hold up.\r\n\r\nThis talk is about what happens when the textbook rules meet messy, real-world code. We’ll rethink what a “unit” really is, explore better ways to test meaningful behavior, and question some long-standing assumptions. Along the way, we’ll take a peek at how AI might help us write better tests — or at least ask better questions.\r\n\r\nIf you’ve ever wondered why your tests don’t quite match the way your code actually works, you’re not alone. Let’s talk about it."
					},
					"speakers": [
						"papp-krisztian"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "scared-excited-and-lost-a-compass-for-the-future-of-work",
					"duration": 45,
					"type": "talk",
					"language": "hr",
					"level": "intermediate",
					"code": "none",
					"originalContentLanguage": "en",
					"title": {
						"hr": "Scared, Excited, and Lost: A Compass for the Future of Work.",
						"en": "Scared, Excited, and Lost: A Compass for the Future of Work."
					},
					"description": {
						"hr": "We were told that technology would free us. Instead, we’ve entered a cycle of relentless acceleration where the 'future of work' arrives every six months. We are progressing faster than ever, yet we feel more lost. In this talk, we explore the paradox of our current moment: Why 'hard skills' like coding are becoming secondary to 'human skills' like empathy, resilience, and critical thinking.\r\n\r\nDrawing from [mention your sources/experience], we will look at how to navigate the 'Excited/Scared' duality. We’ll discuss why the most important tool for the next decade isn't a new AI model—it’s our ability to remain human in an increasingly algorithmic world.",
						"en": "We were told that technology would free us. Instead, we’ve entered a cycle of relentless acceleration where the 'future of work' arrives every six months. We are progressing faster than ever, yet we feel more lost. In this talk, we explore the paradox of our current moment: Why 'hard skills' like coding are becoming secondary to 'human skills' like empathy, resilience, and critical thinking.\r\n\r\nDrawing from [mention your sources/experience], we will look at how to navigate the 'Excited/Scared' duality. We’ll discuss why the most important tool for the next decade isn't a new AI model—it’s our ability to remain human in an increasingly algorithmic world."
					},
					"speakers": [
						"peric-mazar-antonio"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "who-needs-sql",
					"duration": 45,
					"type": "talk",
					"language": "en",
					"level": "intermediate",
					"code": "light",
					"originalContentLanguage": "en",
					"title": {
						"hr": "Who Needs SQL When Your Database Finally Learns to Talk Back?",
						"en": "Who Needs SQL When Your Database Finally Learns to Talk Back?"
					},
					"description": {
						"hr": [
							"<p>While Retrieval-Augmented Generation (RAG) is the gold standard for unstructured data (like PDFs, emails, and Word documents), it is fundamentally the wrong tool for querying structured tabular data (Databases, Data Warehouses, ERPs).</p>",
							"<p>While RAG excels with unstructured text, a metadata-driven Text-to-SQL approach remains the optimal architecture for secure, real-time, and performant corporate data analytics.</p>",
							"<p>Instead, an architecture where the LLM acts as a Semantic Translator (Text-to-SQL) remains the optimal architecture for secure, real-time, and performant corporate data analytics.</p>",
							"<p>Demo included!</p>"
						],
						"en": [
							"<p>While Retrieval-Augmented Generation (RAG) is the gold standard for unstructured data (like PDFs, emails, and Word documents), it is fundamentally the wrong tool for querying structured tabular data (Databases, Data Warehouses, ERPs).</p>",
							"<p>While RAG excels with unstructured text, a metadata-driven Text-to-SQL approach remains the optimal architecture for secure, real-time, and performant corporate data analytics.</p>",
							"<p>Instead, an architecture where the LLM acts as a Semantic Translator (Text-to-SQL) remains the optimal architecture for secure, real-time, and performant corporate data analytics.</p>",
							"<p>Demo included!</p>"
						]
					},
					"speakers": [
						"simic-bruno"
					]
				},
				// { // DID NOT COME
				// 	"visible": true,
				// 	"placeholder": false,
				// 	"ident": "reactive-apps-without-frameworks",
				// 	"duration": 45,
				// 	"type": "talk",
				// 	"language": "en",
				// 	"level": "intermediate",
				// 	"code": "light",
				// 	"originalContentLanguage": "en",
				// 	"title": {
				// 		"hr": "Reactive Apps without Frameworks",
				// 		"en": "Reactive Apps without Frameworks"
				// 	},
				// 	"description": {
				// 		"hr": "Meet a framework-free, zero-deps app stack powered by the near-future web: a tiny signal-based store, DOM-first rendering, and tagged template literals for expressive, safe views.\r\n\r\nSketching an observable state core aligned with the TC39 Signals proposal, with a look to the future to bind it to the DOM using emerging “DOM Parts” ideas for precise updates, finally layering a minimalist template-literal engine that makes JSX feel optional.\r\n\r\nThe result is a reactive, component-capable architecture you can understand in one file, portable from today’s browsers to tomorrow’s platform APIs.\r\n\r\nCome for the WOW, leave with a starter kit for building real apps in vanillaJS. (Proposals: TC39 Signals, DOM Parts, both in active exploration and limited availability.)",
				// 		"en": "Meet a framework-free, zero-deps app stack powered by the near-future web: a tiny signal-based store, DOM-first rendering, and tagged template literals for expressive, safe views.\r\n\r\nSketching an observable state core aligned with the TC39 Signals proposal, with a look to the future to bind it to the DOM using emerging “DOM Parts” ideas for precise updates, finally layering a minimalist template-literal engine that makes JSX feel optional.\r\n\r\nThe result is a reactive, component-capable architecture you can understand in one file, portable from today’s browsers to tomorrow’s platform APIs.\r\n\r\nCome for the WOW, leave with a starter kit for building real apps in vanillaJS. (Proposals: TC39 Signals, DOM Parts, both in active exploration and limited availability.)"
				// 	},
				// 	"speakers": [
				// 		"pisu-emiliano"
				// 	]
				// },
				{
					"visible": true,
					"placeholder": false,
					"ident": "from-prompts-to-purpose-architecting-agentic-ai-in-the-azure-cloud",
					"duration": 45,
					"type": "talk",
					"language": "hr",
					"level": "intermediate",
					"code": "light",
					"originalContentLanguage": "en",
					"title": {
						"hr": "From Prompts to Purpose: Architecting Agentic AI in the Azure Cloud",
						"en": "From Prompts to Purpose: Architecting Agentic AI in the Azure Cloud"
					},
					"description": {
						"hr": "Discover how Agentic AI is transforming modern applications by combining autonomous reasoning with cloud-native scalability. In this session, we'll explore how Microsoft Azure enables the development of intelligent, goal-oriented agents using the powerful AI Foundry framework. You’ll learn how to orchestrate complex workflows with Semantic Kernel SDK, a flexible toolset for building AI agents that can plan, reason, and act. Whether you're building copilots, chatbots, or enterprise workflows, this session will ground you in the practical realities of Agentic AI on Azure.",
						"en": "Discover how Agentic AI is transforming modern applications by combining autonomous reasoning with cloud-native scalability. In this session, we'll explore how Microsoft Azure enables the development of intelligent, goal-oriented agents using the powerful AI Foundry framework. You’ll learn how to orchestrate complex workflows with Semantic Kernel SDK, a flexible toolset for building AI agents that can plan, reason, and act. Whether you're building copilots, chatbots, or enterprise workflows, this session will ground you in the practical realities of Agentic AI on Azure."
					},
					"speakers": [
						"saric-marko"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "invisible-ux-the-interfaces-users-never-notice-but-always-miss",
					"duration": 45,
					"type": "talk",
					"language": "hr",
					"level": "intermediate",
					"code": "none",
					"originalContentLanguage": "en",
					"title": {
						"hr": "Invisible UX: The Interfaces Users Never Notice but Always Miss",
						"en": "Invisible UX: The Interfaces Users Never Notice but Always Miss"
					},
					"description": {
						"hr": "The best UX is often invisible. Users rarely praise what works smoothly but they immediately notice when it fails.\r\nInvisible UX lives in the small, structural decisions that prevent confusion before it appears: clear hierarchy, predictable flows, well-designed defaults, error prevention, consistent interaction patterns. These choices don’t draw attention to themselves. Instead, they remove hesitation, reduce cognitive load, and allow users to stay focused on their goal rather than the interface.\r\nThis talk examines how absence becomes a measurable signal of quality. Fewer support tickets. Shorter onboarding. Lower error rates. Higher task completion. When friction is designed out early, products feel “intuitive” - even though that intuition is carefully engineered.\r\nThrough practical examples, we will identify the invisible layers of interface design that shape user experience without demanding attention. ",
						"en": "The best UX is often invisible. Users rarely praise what works smoothly but they immediately notice when it fails.\r\nInvisible UX lives in the small, structural decisions that prevent confusion before it appears: clear hierarchy, predictable flows, well-designed defaults, error prevention, consistent interaction patterns. These choices don’t draw attention to themselves. Instead, they remove hesitation, reduce cognitive load, and allow users to stay focused on their goal rather than the interface.\r\nThis talk examines how absence becomes a measurable signal of quality. Fewer support tickets. Shorter onboarding. Lower error rates. Higher task completion. When friction is designed out early, products feel “intuitive” - even though that intuition is carefully engineered.\r\nThrough practical examples, we will identify the invisible layers of interface design that shape user experience without demanding attention. "
					},
					"speakers": [
						"slopko-bekavac-barbara"
					]
				},
				{
					"visible": true,
					"placeholder": false,
					"ident": "potentially-real-dangers-of-artificial-intelligence",
					"duration": 45,
					"type": "talk",
					"language": "hr",
					"level": "novice",
					"code": "none",
					"originalContentLanguage": "en",
					"title": {
						"hr": "(Potentially) real dangers of artificial intelligence",
						"en": "(Potentially) real dangers of artificial intelligence"
					},
					"description": {
						"hr": [
							"<p>We have been hearing about artificial intelligence for a while now. The advantages of AI, new technologies, way to utilize them… But it usually starts going in a different direction: Can something go wrong with AI? A very interesting question that always veers into the scenario from a certain cheesy 1984. SF movie starring Arnold Schwarzenegger.</p>",
							"<p>No, ChatGPT will not destroy the world because we made it fix our ugly React code, but there are many interesting scenarios where irresponsible use of AI can lead to unforeseen consequences. You may have already experienced some of them without even knowing.</p>",
							"<p>This talk intends to educate the audience on a different way to talk about AI and its potential dangers. We will go over some lesser-known, but still very interesting AI scenarios and thought experiments and see what kind of future and (potential) dangers of AI they predict, how to recognize these dangers in our own products, and most importantly, how to prevent the worst from happening.</p>"
						],
						"en": [
							"<p>We have been hearing about artificial intelligence for a while now. The advantages of AI, new technologies, way to utilize them… But it usually starts going in a different direction: Can something go wrong with AI? A very interesting question that always veers into the scenario from a certain cheesy 1984. SF movie starring Arnold Schwarzenegger.</p>",
							"<p>No, ChatGPT will not destroy the world because we made it fix our ugly React code, but there are many interesting scenarios where irresponsible use of AI can lead to unforeseen consequences. You may have already experienced some of them without even knowing.</p>",
							"<p>This talk intends to educate the audience on a different way to talk about AI and its potential dangers. We will go over some lesser-known, but still very interesting AI scenarios and thought experiments and see what kind of future and (potential) dangers of AI they predict, how to recognize these dangers in our own products, and most importantly, how to prevent the worst from happening.</p>"
						]
					},
					"speakers": [
						"levacic-filip"
					]
				}
				// { // CANCELLED
				// 	"visible": true,
				// 	"placeholder": false,
				// 	"ident": "copilotkit-and-ag-ui-breaking-free-from-the-chat-box",
				// 	"duration": 45,
				// 	"type": "talk",
				// 	"language": "hr",
				// 	"level": "expert",
				// 	"code": "heavy",
				// 	"originalContentLanguage": "en",
				// 	"title": {
				// 		"hr": "CopilotKit and AG-UI: breaking free from the chat box",
				// 		"en": "CopilotKit and AG-UI: breaking free from the chat box"
				// 	},
				// 	"description": {
				// 		"hr": "AI agents have long been constrained to chat boxes, RAG and agentic use cases that happened in the background, all of which were limited to the traditional request/response model. AG-UI with CopilotKit breaks free from this model, and is allowing the agents to control the React UI. In this talk we'll show how we built a project using Pydantic AI, CopilotKit and React and how we achieved fully shared state of the agent between backend and frontend. This talk is aimed to be useful to both backend (Python) and frontend (React) developers.",
				// 		"en": "AI agents have long been constrained to chat boxes, RAG and agentic use cases that happened in the background, all of which were limited to the traditional request/response model. AG-UI with CopilotKit breaks free from this model, and is allowing the agents to control the React UI. In this talk we'll show how we built a project using Pydantic AI, CopilotKit and React and how we achieved fully shared state of the agent between backend and frontend. This talk is aimed to be useful to both backend (Python) and frontend (React) developers."
				// 	},
				// 	"speakers": [
				// 		"spoljaric-darko",
				// 		"hrlic-marco"
				// 	]
				// }
			],
			speakers: {
				"porobija-marko": {
					"visible": true,
					"placeholder": false,
					"image": "marko-porobija.png",
					"name": "Marko",
					"surname": "Porobija",
					"contact": {},
					"originalContentLanguage": "en",
					"position": {
						"hr": "Managing Partner @ Porobija & Špoljarić",
						"en": "Managing Partner @ Porobija & Špoljarić"
					},
					"bio": {
						"hr": [
							"Marko began his career at Porobija & Špoljarić immediately after graduating from law school. Over time, he specialized in M&A transactions and has also become one of the firm’s experts in AI law.",
							"He is the CEO of the firm and one of the leads of the Special Operations team. Marko’s mission is to make legal services more accessible by introducing the latest technologies into the legal profession.",
							"In line with the firm’s policy of promoting alternative dispute resolution, Marko strongly advocates for amicable settlements and is a certified mediator.",
							"Outside of work, Marko enjoys music, reading, gaming, and sports, hobbies he can easily spend hours on."
						],
						"en": [
							"Marko began his career at Porobija & Špoljarić immediately after graduating from law school. Over time, he specialized in M&A transactions and has also become one of the firm’s experts in AI law.",
							"He is the CEO of the firm and one of the leads of the Special Operations team. Marko’s mission is to make legal services more accessible by introducing the latest technologies into the legal profession.",
							"In line with the firm’s policy of promoting alternative dispute resolution, Marko strongly advocates for amicable settlements and is a certified mediator.",
							"Outside of work, Marko enjoys music, reading, gaming, and sports, hobbies he can easily spend hours on."
						]
					},
					"social": {
						linkedIn: "https://www.linkedin.com/in/markoporobija"
					}
				},
				"duric-marko": {
					"visible": true,
					"placeholder": false,
					"image": "marko-duric.jpg",
					"name": "Marko",
					"surname": "Đurić",
					"contact": {
						"email": "marko.djuric@psod.hr"
					},
					"originalContentLanguage": "hr",
					"position": {
						"hr": "Odvjetnik u Odvjetničkom društvu Porobija & Špoljarić d.o.o.",
						"en": "Odvjetnik u Odvjetničkom društvu Porobija & Špoljarić d.o.o."
					},
					"bio": {
						"hr": "Marko Đurić je odvjetnik u Odvjetničkom društvu Porobija & Špoljarić d.o.o. gdje pruža pravna savjetovanja klijentima iz tehnološkog sektora, s posebnim fokusom na ICT/TMT, ugovorne odnose i regulatorna pitanja digitalnog poslovanja, a diplomirao je na Pravnom fakultetu Sveučilišta u Zagrebu. Stručnjak je za regulatorni okvir umjetne inteligencije, zaštitu podataka i pravo intelektualnog vlasništva, s fokusom na pravne i strateške implikacije primjene umjetne inteligencije u poslovanju. Djeluje kao edukator na području pravnog i regulatornog upravljanja rizicima umjetne inteligencije u poslovanju, uključujući AI Act, prompt inženjering iz pravne perspektive, regulatornu usklađenost i zaštitu intelektualnog kapitala u digitalnom okruženju. Autor je akademskog istraživanja iz područja razvoja i implementacije Legal Tech rješenja, te ima praktična iskustva u razvoju i primjeni Legal Tech alata.",
						"en": "Marko Đurić je odvjetnik u Odvjetničkom društvu Porobija & Špoljarić d.o.o. gdje pruža pravna savjetovanja klijentima iz tehnološkog sektora, s posebnim fokusom na ICT/TMT, ugovorne odnose i regulatorna pitanja digitalnog poslovanja, a diplomirao je na Pravnom fakultetu Sveučilišta u Zagrebu. Stručnjak je za regulatorni okvir umjetne inteligencije, zaštitu podataka i pravo intelektualnog vlasništva, s fokusom na pravne i strateške implikacije primjene umjetne inteligencije u poslovanju. Djeluje kao edukator na području pravnog i regulatornog upravljanja rizicima umjetne inteligencije u poslovanju, uključujući AI Act, prompt inženjering iz pravne perspektive, regulatornu usklađenost i zaštitu intelektualnog kapitala u digitalnom okruženju. Autor je akademskog istraživanja iz područja razvoja i implementacije Legal Tech rješenja, te ima praktična iskustva u razvoju i primjeni Legal Tech alata."
					},
					"social": {
						linkedIn: "https://www.linkedin.com/in/marko-%C4%91uri%C4%87"
					}
				},
				"adanic-alen": {
					"visible": true,
					"placeholder": false,
					"image": "alen-adanic.jpg",
					"name": "Alen",
					"surname": "Adanić",
					"contact": {
						"email": "alen.adanic@gmail.com"
					},
					"originalContentLanguage": "en",
					"position": {
						"hr": "Head of Software Products Development @ Abysalto",
						"en": "Head of Software Products Development @ Abysalto"
					},
					"bio": {
						"hr": "Alen is the Head of Software Product Development at Abysalto, a Croatian software company focused on smart transport solutions. With over 10 years of experience in IT, he combines product development expertise with a strong focus on building secure, cloud-native development platforms. He has been actively involved in establishing a Kubernetes-based development ecosystem that integrates security practices such as SAST, DAST, SCA, and ASPM — enabling faster delivery while improving security posture and simplifying regulatory compliance.",
						"en": "Alen is the Head of Software Product Development at Abysalto, a Croatian software company focused on smart transport solutions. With over 10 years of experience in IT, he combines product development expertise with a strong focus on building secure, cloud-native development platforms. He has been actively involved in establishing a Kubernetes-based development ecosystem that integrates security practices such as SAST, DAST, SCA, and ASPM — enabling faster delivery while improving security posture and simplifying regulatory compliance."
					},
					"social": {
						"linkedIn": "https://www.linkedin.com/in/alen-adanic?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
					}
				},
				"bronzin-tomislav": {
					"visible": true,
					"placeholder": false,
					"image": "tomislav-bronzin.png",
					"name": "Tomislav",
					"surname": "Bronzin",
					"contact": {
						"email": "tbronzin@citus.hr"
					},
					"originalContentLanguage": "en",
					"position": {
						"hr": "CEO, Microsoft Regional Director & MVP @ CITUS",
						"en": "CEO, Microsoft Regional Director & MVP @ CITUS"
					},
					"bio": {
						"hr": "Tomislav Bronzin is Microsoft Regional Director & Microsoft Most Valuable Professional (21th year in a row!) - M365 Apps and founder of CITUS, a Microsoft Partner Company specializing in software development, consulting, and training. He is leading CITUS Team, and managing projects focused on Microsoft365, Power Platform, Mixed Reality, AI, Big Data & Cloud Computing. Tomislav is a trainer and speaker at Microsoft conferences like TechEd Europe, WindDays, NT Konferenca, MS NetWork, CrisCon, Weblica, KulenDayz, Init Conference, etc. He teaches at several universities and mentors student teams for the Imagine Cup Competition. Tomislav organized the http://www.mobilityday.com conference (10 years in a row!) and is helping to organize one of the largest MS Community Conferences in the region - KulenDayz. Tomislav is one of the founders of MS Community in Croatia and the Croatian Chamber of Economy IT Association Vice President. He is also an entrepreneur and innovator who (with his team) has won over 124 international awards for his IT inventions, five patents, and many other recognitions. Tomislav has led the CITUS Team in developing numerous innovative software products based on propriety innovations in artificial intelligence, mixed reality, big data, and cloud computing. ",
						"en": "Tomislav Bronzin is Microsoft Regional Director & Microsoft Most Valuable Professional (21th year in a row!) - M365 Apps and founder of CITUS, a Microsoft Partner Company specializing in software development, consulting, and training. He is leading CITUS Team, and managing projects focused on Microsoft365, Power Platform, Mixed Reality, AI, Big Data & Cloud Computing. Tomislav is a trainer and speaker at Microsoft conferences like TechEd Europe, WindDays, NT Konferenca, MS NetWork, CrisCon, Weblica, KulenDayz, Init Conference, etc. He teaches at several universities and mentors student teams for the Imagine Cup Competition. Tomislav organized the http://www.mobilityday.com conference (10 years in a row!) and is helping to organize one of the largest MS Community Conferences in the region - KulenDayz. Tomislav is one of the founders of MS Community in Croatia and the Croatian Chamber of Economy IT Association Vice President. He is also an entrepreneur and innovator who (with his team) has won over 124 international awards for his IT inventions, five patents, and many other recognitions. Tomislav has led the CITUS Team in developing numerous innovative software products based on propriety innovations in artificial intelligence, mixed reality, big data, and cloud computing. "
					},
					"social": {
						"linkedIn": "https://www.linkedin.com/in/tbronzin/"
					}
				},
				"breznjak-nikola": {
					"visible": true,
					"placeholder": false,
					"image": "nikola-breznjak.jpg",
					"name": "Nikola",
					"surname": "Brežnjak",
					"contact": {
						"email": "nikola.breznjak@gmail.com"
					},
					"originalContentLanguage": "en",
					"position": {
						"hr": "Senior Jack of All Trades",
						"en": "Senior Jack of All Trades"
					},
					"bio": {
						"hr": "\r\nI’m an engineer at heart and a jack of all trades kind of guy.\r\n\r\nFor those who care about titles, I hold a masters degree in computing from FER (and a black belt in karate, but that’s another story…).\r\n\r\nDuring the last years, I worked in a betting software industry where I made use of my knowledge in areas ranging from full-stack (web & desktop) development to game development through Linux and database administration and use of various languages (C#, PHP, JavaScript to name just a few).\r\n\r\nCurrently, I’m a senior software engineer at TelTech, where we make innovative communications apps, and I <3 it.\r\n\r\nLately, I’m very passionate about Ionic framework and am currently in the top 3 answerers on StackOverflow in Ionic framework. I wrote a book about Ionic framework which you can get for free on Leanpub: Ionic framework – step by step from idea through prototyping to the app stores.\r\n\r\nIn my free time, I love to play board games.",
						"en": "\r\nI’m an engineer at heart and a jack of all trades kind of guy.\r\n\r\nFor those who care about titles, I hold a masters degree in computing from FER (and a black belt in karate, but that’s another story…).\r\n\r\nDuring the last years, I worked in a betting software industry where I made use of my knowledge in areas ranging from full-stack (web & desktop) development to game development through Linux and database administration and use of various languages (C#, PHP, JavaScript to name just a few).\r\n\r\nCurrently, I’m a senior software engineer at TelTech, where we make innovative communications apps, and I <3 it.\r\n\r\nLately, I’m very passionate about Ionic framework and am currently in the top 3 answerers on StackOverflow in Ionic framework. I wrote a book about Ionic framework which you can get for free on Leanpub: Ionic framework – step by step from idea through prototyping to the app stores.\r\n\r\nIn my free time, I love to play board games."
					},
					"social": {
						"linkedIn": "https://www.linkedin.com/in/nikola-bre%C5%BEnjak-892b9a24/"
					}
				},
				"cindric-gordon": {
					"visible": true,
					"placeholder": false,
					"image": "gordon-cindric.png",
					"name": "Gordon",
					"surname": "Cindrić",
					"contact": {
						"email": "gordon@mcknightmedia.co"
					},
					"originalContentLanguage": "en",
					"position": {
						"hr": "CEO & Lead Product Designer @ McKnight Media",
						"en": "CEO & Lead Product Designer @ McKnight Media"
					},
					"bio": {
						"hr": "Gordon is an experience product designer, team leader and mentor who spent over 15 years designing UX for countless digital products of all types and sizes. For the last 5 years, he's been building a niche design agency specialized in designing UX for complex, domain-specific, enterprise software. McKnight Media has also recently expanded it's services to include product management and B2B UX training for non-designers.",
						"en": "Gordon is an experience product designer, team leader and mentor who spent over 15 years designing UX for countless digital products of all types and sizes. For the last 5 years, he's been building a niche design agency specialized in designing UX for complex, domain-specific, enterprise software. McKnight Media has also recently expanded it's services to include product management and B2B UX training for non-designers."
					},
					"social": {
						"linkedIn": "https://www.linkedin.com/in/gordoncindric/"
					}
				},
				"duranec-erik": {
					"visible": true,
					"placeholder": false,
					"image": "erik-duranec.jpg",
					"name": "Erik",
					"surname": "Đuranec",
					"contact": {
						"email": "erik.djuranec@gmail.com"
					},
					"originalContentLanguage": "en",
					"position": {
						"hr": "Data Scientist @ Infobip",
						"en": "Data Scientist @ Infobip"
					},
					"bio": {
						"hr": "Erik Đuranec is a Data Scientist at Infobip specializing in the design and deployment of large-scale intelligent systems. Since 2023, he has pivoted beyond traditional modeling to focus on data monetization and the implementation of AI architecture at a global scale. A former participant in prestigious programs like Roche Continents and Huawei’s Seeds for the Future, Erik combines a deep academic foundation from FOI with a pragmatic approach to building value-driven technology. When he isn't architecting data solutions, he spends his time traveling the world, diving into a good book, or engaging in spirited conversation with his dog.",
						"en": "Erik Đuranec is a Data Scientist at Infobip specializing in the design and deployment of large-scale intelligent systems. Since 2023, he has pivoted beyond traditional modeling to focus on data monetization and the implementation of AI architecture at a global scale. A former participant in prestigious programs like Roche Continents and Huawei’s Seeds for the Future, Erik combines a deep academic foundation from FOI with a pragmatic approach to building value-driven technology. When he isn't architecting data solutions, he spends his time traveling the world, diving into a good book, or engaging in spirited conversation with his dog."
					},
					"social": {
						"linkedIn": "https://www.linkedin.com/in/erikduranec/"
					}
				},
				"drljevic-omar": {
					"visible": true,
					"placeholder": false,
					"image": "omar-drljevic.jpg",
					"name": "Omar",
					"surname": "Drljevic",
					"contact": {
						"email": "omar.drljevic@ebcont.com"
					},
					"originalContentLanguage": "en",
					"position": {
						"hr": "AI & Data Consultant @ Ebcont",
						"en": "AI & Data Consultant @ Ebcont"
					},
					"bio": {
						"hr": "AI & Data Consultant at EBCONT, building intelligent systems that turn complex data into actionable insights. I specialize in Agentic AI, Retrieval-Augmented Generation (RAG), Large Language Models, Graph Databases, data engineering, and scalable cloud-native architectures on AWS.\r\nMy focus areas include designing AI and data pipelines, intelligent search, automation, and adaptive workflows. Recent work includes building a local RAG system that improved query accuracy from 60% to over 97% on complex German-language data warehouses in energy industry — using open-source tooling and cost-efficient inference.\r\nPreviously, I worked as a Student Research Assistant at TU Wien's Institute of Management Science, developing computer vision and deep learning solutions for manufacturing and assistive technologies — contributing to adaptive systems for cobots, VR, and exoskeletons within a multidisciplinary research team.\r\nI hold a Master's in Business Informatics (Data Science) from TU Wien and a Bachelor's in Computer Science from the University of Buckingham, along with certifications in AWS (Cloud Practitioner, AI Practitioner), Neo4j, Microsoft Fabric, and Deep Learning with PyTorch.\r\n4+ years of software engineering experience. Fluent in English, proficient in German and Bosnian.",
						"en": "AI & Data Consultant at EBCONT, building intelligent systems that turn complex data into actionable insights. I specialize in Agentic AI, Retrieval-Augmented Generation (RAG), Large Language Models, Graph Databases, data engineering, and scalable cloud-native architectures on AWS.\r\nMy focus areas include designing AI and data pipelines, intelligent search, automation, and adaptive workflows. Recent work includes building a local RAG system that improved query accuracy from 60% to over 97% on complex German-language data warehouses in energy industry — using open-source tooling and cost-efficient inference.\r\nPreviously, I worked as a Student Research Assistant at TU Wien's Institute of Management Science, developing computer vision and deep learning solutions for manufacturing and assistive technologies — contributing to adaptive systems for cobots, VR, and exoskeletons within a multidisciplinary research team.\r\nI hold a Master's in Business Informatics (Data Science) from TU Wien and a Bachelor's in Computer Science from the University of Buckingham, along with certifications in AWS (Cloud Practitioner, AI Practitioner), Neo4j, Microsoft Fabric, and Deep Learning with PyTorch.\r\n4+ years of software engineering experience. Fluent in English, proficient in German and Bosnian."
					},
					"social": {
						"linkedIn": "https://www.linkedin.com/in/omar-drljevic/"
					}
				},
				"gheorghiu-catalin": {
					"visible": true,
					"placeholder": false,
					"image": "catalin-gheorghiu.jpg",
					"name": "Catalin",
					"surname": "Gheorghiu",
					"contact": {
						"email": "gheorghiu.catalin@gmail.com"
					},
					"originalContentLanguage": "en",
					"position": {
						"hr": "Solution Architect @ Epam Systems",
						"en": "Solution Architect @ Epam Systems"
					},
					"bio": {
						"hr": "Catalin Gheorghiu is a solution architect from Timisoara Romania. The current interests are in the area of (I)IoT, industrial mobile and cloud solutions. In addition to addressing the software development and architecture, is a trainer and consultant. In his spare time is member of the technical community, contributing with articles and blogs (signed MrSmersh), presentations to several user groups/meetups (also is RONUA Timisoara user group leader), and lecturing all over Romania and abroad. \r\nSince 2011, every year he was awarded the Microsoft MVP Award. Is also a current holder of the Intel Software Innovator Award. Is a current Microsoft Certified Trainer.\r\n",
						"en": "Catalin Gheorghiu is a solution architect from Timisoara Romania. The current interests are in the area of (I)IoT, industrial mobile and cloud solutions. In addition to addressing the software development and architecture, is a trainer and consultant. In his spare time is member of the technical community, contributing with articles and blogs (signed MrSmersh), presentations to several user groups/meetups (also is RONUA Timisoara user group leader), and lecturing all over Romania and abroad. \r\nSince 2011, every year he was awarded the Microsoft MVP Award. Is also a current holder of the Intel Software Innovator Award. Is a current Microsoft Certified Trainer.\r\n"
					},
					"social": {
						"linkedIn": "https://www.linkedin.com/in/catalingheorghiu/"
					}
				},
				"huizendveld-marijn": {
					"visible": true,
					"placeholder": false,
					"image": "marijn-huizendveld.jpg",
					"name": "Marijn",
					"surname": "Huizendveld",
					"contact": {
						"email": "marijn@huizendveld.com"
					},
					"originalContentLanguage": "en",
					"position": {
						"hr": "Founder @ Try it with Ann",
						"en": "Founder @ Try it with Ann"
					},
					"bio": {
						"hr": "In a small backstreet of Tokyo lives a man named Aki, a 78-year-old former chef. Aki spent most of his life trying to perfectly cook the rice he buys from his friend Mato. He's been at it for 57 years now and still searches for ways to improve his cooking methods. There is probably not too much anybody else could tell Aki about cooking this specific type of rice. \r\n\r\nWhen it comes to his process, Aki's understanding is unrivaled. After years of trial and glorious error, Marijn could be called the Aki of Domain-Driven Design, due to his extensive background in both programming and strategy. He uses this experience to show teams and organizations how to recognize and act on problems and opportunities in an autonomous, self-learning fashion. \r\n\r\nBringing an objective outsider’s view to the table, Marijn uses today's challenges of your organization to make your people truly aware of their environment. \r\nNot by nudging and pushing them towards the final goal, but by offering them the tools to find a path on their own. Once on the road, positive feedback, mentoring, determination, and a positive vibe allow teams to try, to make mistakes, to investigate, and to learn. \r\n\r\nThat’s the mindset Marijn will add to your organization.",
						"en": "In a small backstreet of Tokyo lives a man named Aki, a 78-year-old former chef. Aki spent most of his life trying to perfectly cook the rice he buys from his friend Mato. He's been at it for 57 years now and still searches for ways to improve his cooking methods. There is probably not too much anybody else could tell Aki about cooking this specific type of rice. \r\n\r\nWhen it comes to his process, Aki's understanding is unrivaled. After years of trial and glorious error, Marijn could be called the Aki of Domain-Driven Design, due to his extensive background in both programming and strategy. He uses this experience to show teams and organizations how to recognize and act on problems and opportunities in an autonomous, self-learning fashion. \r\n\r\nBringing an objective outsider’s view to the table, Marijn uses today's challenges of your organization to make your people truly aware of their environment. \r\nNot by nudging and pushing them towards the final goal, but by offering them the tools to find a path on their own. Once on the road, positive feedback, mentoring, determination, and a positive vibe allow teams to try, to make mistakes, to investigate, and to learn. \r\n\r\nThat’s the mindset Marijn will add to your organization."
					},
					"social": {
						"linkedIn": "https://linkedin.com/in/marijnhuizendveld/"
					}
				},
				"irving-mike": {
					"visible": true,
					"placeholder": false,
					"image": "mike-irving.jpg",
					"name": "Mike",
					"surname": "Irving",
					"contact": {
						"email": "mike@mike-irving.co.uk"
					},
					"originalContentLanguage": "en",
					"position": {
						"hr": "Cross-platform Software Developer. Speaker. Microsoft MVP. Co-organiser of Dot Net North and Macc Tech",
						"en": "Cross-platform Software Developer. Speaker. Microsoft MVP. Co-organiser of Dot Net North and Macc Tech"
					},
					"bio": {
						"hr": "A professional developer for over 20 years, based in Macclesfield.\r\n\r\nFor the past 10+ years I have been heavily involved in mobile development, and have utilised  both Native code (Swift, Kotlin, Objective-C, Java) and Cross-Platform app development systems including Xamarin, .NET MAUI, Uno Platform and Cordova on different projects.\r\n\r\nA constant in my journey has been the use of C# / .NET.\r\n\r\nI also do web development work, and I equally happy front-end in HTML, CSS and JavaScript.\r\n\r\nMicrosoft MVP. Co-organiser of Dot Net North and Macc Tech.\r\n\r\nRegular speaker and presenter.",
						"en": "A professional developer for over 20 years, based in Macclesfield.\r\n\r\nFor the past 10+ years I have been heavily involved in mobile development, and have utilised  both Native code (Swift, Kotlin, Objective-C, Java) and Cross-Platform app development systems including Xamarin, .NET MAUI, Uno Platform and Cordova on different projects.\r\n\r\nA constant in my journey has been the use of C# / .NET.\r\n\r\nI also do web development work, and I equally happy front-end in HTML, CSS and JavaScript.\r\n\r\nMicrosoft MVP. Co-organiser of Dot Net North and Macc Tech.\r\n\r\nRegular speaker and presenter."
					},
					"social": {
						"linkedIn": "https://www.linkedin.com/in/mikeirving/"
					}
				},
				"knezevic-karlo": {
					"visible": true,
					"placeholder": false,
					"keynote": true,
					"image": "karlo-knezevic.jpg",
					"name": "Karlo",
					"surname": "Knežević",
					"contact": {
					},
					"originalContentLanguage": "en",
					"position": {
						"hr": "Head of AI @ Sofascore",
						"en": "Head of AI @ Sofascore",
					},
					"bio": {
						hr: [
							"Dr. Karlo Knežević holds a PhD in Computer Science and is an expert in artificial intelligence and data processing. He is employed as the Head of AI at Sofascore, where he is responsible for strategic development, leading AI teams, and implementing advanced systems in a production environment. He actively bridges scientific research and industry practice through research and development, educational, and professional projects at both national and international levels. He places particular emphasis on responsible technology management and people development."
						],
						en: [
							"Dr. Karlo Knežević holds a PhD in Computer Science and is an expert in artificial intelligence and data processing. He is employed as the Head of AI at Sofascore, where he is responsible for strategic development, leading AI teams, and implementing advanced systems in a production environment. He actively bridges scientific research and industry practice through research and development, educational, and professional projects at both national and international levels. He places particular emphasis on responsible technology management and people development."
						]
					},
					"social": {
						linkedIn: "https://www.linkedin.com/in/karloknezevic/"
					}
				},
				"lohert-marko": {
					"visible": true,
					"placeholder": false,
					"image": "marko-lohert.jpg",
					"name": "Marko",
					"surname": "Lohert",
					"contact": {
						"email": "lohert.marko@gmail.com"
					},
					"originalContentLanguage": "hr",
					"position": {
						"hr": "Senior Software Developer @ Span",
						"en": "Senior Software Developer @ Span"
					},
					"bio": {
						"hr": "Marko Lohert, diplomirani inženjer računarstva, radi kao developer od 2005. godine. Dobitnik je Godišnje nagrade ZTK Zagrebačke županije za postignute rezultate na područjima programiranja i robotike. Bavi se razvojem aplikacija za web i desktop te pri tome u radu koristi različite baze podataka. Predavao je na nizu konferencija u Hrvatskoj te u Bosni i Hercegovini. Bio je predavač i na meetupima u Hrvatskoj, Bosni i Hercegovini te u Austriji. Zaposlen je u Spanu. U slobodno vrijeme volontira. S jedne strane volontira kao mentor u Mentoring Byte programu Change Instituta namijenjenom novim programerima, UX/UI stručnjacima, testerima itd. Uz to s druge strane volontira s djecom na područjima programiranja, elektronike (Arduino) i robotike.",
						"en": "Marko Lohert, diplomirani inženjer računarstva, radi kao developer od 2005. godine. Dobitnik je Godišnje nagrade ZTK Zagrebačke županije za postignute rezultate na područjima programiranja i robotike. Bavi se razvojem aplikacija za web i desktop te pri tome u radu koristi različite baze podataka. Predavao je na nizu konferencija u Hrvatskoj te u Bosni i Hercegovini. Bio je predavač i na meetupima u Hrvatskoj, Bosni i Hercegovini te u Austriji. Zaposlen je u Spanu. U slobodno vrijeme volontira. S jedne strane volontira kao mentor u Mentoring Byte programu Change Instituta namijenjenom novim programerima, UX/UI stručnjacima, testerima itd. Uz to s druge strane volontira s djecom na područjima programiranja, elektronike (Arduino) i robotike."
					},
					"social": {
						"linkedIn": "https://www.linkedin.com/in/marko-lohert/"
					}
				},
				"matosa-igor": {
					"visible": true,
					"placeholder": false,
					"image": "igor-matosa.jpg",
					"name": "Igor",
					"surname": "Matoša",
					"contact": {
						"email": "igor.matosa@gmail.com"
					},
					"originalContentLanguage": "hr",
					"position": {
						"hr": "Frontend Developer @ Span",
						"en": "Frontend Developer @ Span"
					},
					"bio": {
						"hr": "Razvojni inženjer u Span d.d.-u s više od 20 godina iskustva u web programiranju i razvoju kompleksnih digitalnih sustava. Profesionalno se bavi modernim web tehnologijama i arhitekturama, dok u slobodno vrijeme istražuje IoT rješenja, eksperimentira s pametnim uređajima te se kreativno izražava kroz fotografiju.",
						"en": "Razvojni inženjer u Span d.d.-u s više od 20 godina iskustva u web programiranju i razvoju kompleksnih digitalnih sustava. Profesionalno se bavi modernim web tehnologijama i arhitekturama, dok u slobodno vrijeme istražuje IoT rješenja, eksperimentira s pametnim uređajima te se kreativno izražava kroz fotografiju."
					},
					"social": {
						"linkedIn": "https://www.linkedin.com/in/imatosa/"
					}
				},
				"peric-mazar-antonio": {
					"visible": true,
					"placeholder": false,
					"image": "antonio-peric-mazar.jpg",
					"name": "Antonio",
					"surname": "Perić-Mažar",
					"contact": {
						"email": "antonio@locastic.com"
					},
					"originalContentLanguage": "en",
					"position": {
						"hr": "CEO @ Locastic",
						"en": "CEO @ Locastic"
					},
					"bio": {
						"hr": "Antonio Perić-Mažar is the CEO of Locastic, company focused on product development. A \"digital witness\" who has followed the internet since day one, Antonio is an international speaker exploring the paradox of progress. He argues that in an AI-driven world, our most vital skills aren't coding, but the human traits that keep us grounded. From delivering software to his interests in Blockchain, Antonio is dedicated to helping leaders navigate a future where being human is the ultimate competitive advantage.",
						"en": "Antonio Perić-Mažar is the CEO of Locastic, company focused on product development. A \"digital witness\" who has followed the internet since day one, Antonio is an international speaker exploring the paradox of progress. He argues that in an AI-driven world, our most vital skills aren't coding, but the human traits that keep us grounded. From delivering software to his interests in Blockchain, Antonio is dedicated to helping leaders navigate a future where being human is the ultimate competitive advantage."
					},
					"social": {}
				},
				"simic-bruno": {
					visible: true,
					placeholder: false,
					image: "simic-bruno.png",
					name: "Bruno",
					surname: "Šimić",
					contact: {
						email: "bruno@simicmail.com",
						phone: "+385953536050",
					},
					position: {
						hr: "",
						en: "", // missing info
					},
					bio: {
						hr: "",
						en: "", // missing info
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/brunosimic",
					},
				},
				// "pisu-emiliano": { // DID NOT COME
				// 	"visible": true,
				// 	"placeholder": false,
				// 	"image": "emiliano-pisu.png",
				// 	"name": "Emiliano",
				// 	"surname": "Pisu",
				// 	"contact": {
				// 		"email": "pisuemiliano.1980@gmail.com"
				// 	},
				// 	"originalContentLanguage": "en",
				// 	"position": {
				// 		"hr": "Senior Design Engineer, Sensei & Co-Host @ DevDojoIT",
				// 		"en": "Senior Design Engineer, Sensei & Co-Host @ DevDojoIT"
				// 	},
				// 	"bio": {
				// 		"hr": "Hi 👋 Folks!\r\nI’m Emiliano Pisu, your friendly neighborhood Design Engineer.\r\n\r\nThroughout my career, driven by my coding addiction, I’ve always stayed up to date with software development and related trends, focusing on UI, UX, Accessibility, Responsiveness, Compatibility, Scalability, and Maintainability.\r\n\r\nMy main goal is to build accessible and pixel-perfect user interfaces that enhance the user experience.\r\n\r\nMy core approach is to develop with zero dependencies, fostering creativity, learning, experimentation, and deep knowledge. This leads to solutions that not only follow trends but are also carefully tailored to the needs of clients and stakeholders.\r\n\r\nI am deeply committed to knowledge sharing and mentorship: through my experience as Sensei @ Dev Dojo IT, I actively support those who want to grow in the frontend world and in designing accessible and scalable interfaces.\r\n\r\nIn conclusion, I’m the right person if you need a bridge between Design and Development. I live to simplify my colleagues' DevX, which is why I focus on advocating for the core technologies of the web, strictly vanilla.",
				// 		"en": "Hi 👋 Folks!\r\nI’m Emiliano Pisu, your friendly neighborhood Design Engineer.\r\n\r\nThroughout my career, driven by my coding addiction, I’ve always stayed up to date with software development and related trends, focusing on UI, UX, Accessibility, Responsiveness, Compatibility, Scalability, and Maintainability.\r\n\r\nMy main goal is to build accessible and pixel-perfect user interfaces that enhance the user experience.\r\n\r\nMy core approach is to develop with zero dependencies, fostering creativity, learning, experimentation, and deep knowledge. This leads to solutions that not only follow trends but are also carefully tailored to the needs of clients and stakeholders.\r\n\r\nI am deeply committed to knowledge sharing and mentorship: through my experience as Sensei @ Dev Dojo IT, I actively support those who want to grow in the frontend world and in designing accessible and scalable interfaces.\r\n\r\nIn conclusion, I’m the right person if you need a bridge between Design and Development. I live to simplify my colleagues' DevX, which is why I focus on advocating for the core technologies of the web, strictly vanilla."
				// 	},
				// 	"social": {
				// 		"linkedIn": "https://www.linkedin.com/in/pixu1980"
				// 	}
				// },
				"papp-krisztian": {
					"visible": true,
					"placeholder": false,
					"image": "krisztian-papp.jpg",
					"name": "Krisztián",
					"surname": "Papp",
					"contact": {
						"email": "tacsiazuma@gmail.com"
					},
					"originalContentLanguage": "en",
					"position": {
						"hr": "Consultant @ Letscode Solutions",
						"en": "Consultant @ Letscode Solutions"
					},
					"bio": {
						"hr": "Krisztián is a software architect and consultant with over a decade of hands-on experience in designing, building, and evolving complex software systems. After years in senior engineering leadership roles, he founded his own consulting company, where he helps organizations modernize their architecture, accelerate delivery, and build sustainable engineering practices.\n\nHe specializes in cloud transformations, DevOps practices, architectural decision-making (ADR), and pragmatic system design. Krisztián is also the founder of the Letscode.hu community, creating a supportive environment where individuals can thrive, share their knowledge, and collectively contribute to the advancement of technology.",
						"en": "Krisztián is a software architect and consultant with over a decade of hands-on experience in designing, building, and evolving complex software systems. After years in senior engineering leadership roles, he founded his own consulting company, where he helps organizations modernize their architecture, accelerate delivery, and build sustainable engineering practices.\n\nHe specializes in cloud transformations, DevOps practices, architectural decision-making (ADR), and pragmatic system design. Krisztián is also the founder of the Letscode.hu community, creating a supportive environment where individuals can thrive, share their knowledge, and collectively contribute to the advancement of technology."
					},
					"social": {
						"linkedIn": "https://www.linkedin.com/in/papp-krisztian/"
					}
				},
				"saric-marko": {
					"visible": true,
					"placeholder": false,
					"image": "marko-saric.jpg",
					"name": "Marko",
					"surname": "Šarić",
					"contact": {
						"email": "marko.saric@icloud.com"
					},
					"originalContentLanguage": "hr",
					"position": {
						"hr": "Senior Software Engineer @ Syskit",
						"en": "Senior Software Engineer @ Syskit"
					},
					"bio": {
						"hr": "Marko se bavi razvojem aplikacija i predavanjima na različitim community događanjima. Primarno radi s Microsoftovim tehnološkim stackom, razvijajući web, mobilna i Azure-temeljena rješenja.\r\n\r\nTijekom svoje karijere sudjelovao je u brojnim projektima za domaće i inozemne klijente, govorio na nekoliko lokalnih konferencija te stekao više Microsoftovih certifikata iz područja razvoja web aplikacija, agilnih razvojnih metodologija, cloud platformi i upravljanja životnim ciklusom aplikacija.\r\n\r\nObnašao je različite uloge, od softverskog developera i voditelja razvojnog tima do DevOps konzultanta, pomažući organizacijama u izgradnji snažnih i samoodrživih DevOps timova te uvođenju procesa upravljanja životnim ciklusom aplikacija koji agilnim timovima omogućuju učinkovitiju suradnju i bržu isporuku.\r\n\r\nStrastveni je ljubitelj Apple ekosustava, a uživa i u eksperimentiranju s najnovijim Microsoftovim alatima na macOS-u. Kada se udalji od tipkovnice, prste isteže svirajući gitaru ili skuplja kilometre vozeći brdski bicikl.\r\n\r\n",
						"en": "Marko se bavi razvojem aplikacija i predavanjima na različitim community događanjima. Primarno radi s Microsoftovim tehnološkim stackom, razvijajući web, mobilna i Azure-temeljena rješenja.\r\n\r\nTijekom svoje karijere sudjelovao je u brojnim projektima za domaće i inozemne klijente, govorio na nekoliko lokalnih konferencija te stekao više Microsoftovih certifikata iz područja razvoja web aplikacija, agilnih razvojnih metodologija, cloud platformi i upravljanja životnim ciklusom aplikacija.\r\n\r\nObnašao je različite uloge, od softverskog developera i voditelja razvojnog tima do DevOps konzultanta, pomažući organizacijama u izgradnji snažnih i samoodrživih DevOps timova te uvođenju procesa upravljanja životnim ciklusom aplikacija koji agilnim timovima omogućuju učinkovitiju suradnju i bržu isporuku.\r\n\r\nStrastveni je ljubitelj Apple ekosustava, a uživa i u eksperimentiranju s najnovijim Microsoftovim alatima na macOS-u. Kada se udalji od tipkovnice, prste isteže svirajući gitaru ili skuplja kilometre vozeći brdski bicikl.\r\n\r\n"
					},
					"social": {
						"linkedIn": "https://www.linkedin.com/in/saricmarko/"
					}
				},
				// "spoljaric-darko": { // CANCELLED
				// 	"visible": true,
				// 	"placeholder": false,
				// 	"image": "darko-spoljaric.png",
				// 	"name": "Darko",
				// 	"surname": "Špoljarić",
				// 	"contact": {
				// 		"email": "darko.spoljaric@wearenotch.com"
				// 	},
				// 	"originalContentLanguage": "en",
				// 	"position": {
				// 		"hr": "Vicepresident of AI @ Notch",
				// 		"en": "Vicepresident of AI @ Notch"
				// 	},
				// 	"bio": {
				// 		"hr": "Darko Špoljarić is an enterprise Java developer that turned to AI in the last couple of years. His focus is adoption of the latest AI technologies in Notch, both in building AI native products, and using the technology to be stronger engineer. Outside of work Darko is spending most of his time with his family, and goes for an occasional run.",
				// 		"en": "Darko Špoljarić is an enterprise Java developer that turned to AI in the last couple of years. His focus is adoption of the latest AI technologies in Notch, both in building AI native products, and using the technology to be stronger engineer. Outside of work Darko is spending most of his time with his family, and goes for an occasional run."
				// 	},
				// 	"social": {
				// 		"linkedIn": "https://www.linkedin.com/in/darko-%C5%A1poljari%C4%87-8a303587/"
				// 	}
				// },
				// "hrlic-marco": { // cancelled
				// 	"visible": true,
				// 	"placeholder": false,
				// 	"image": "hrlic-marco.png",
				// 	"name": "Marco",
				// 	"surname": "Hrlić",
				// 	"contact": {
				// 		"email": "marco.hrlic@wearenotch.com"
				// 	},
				// 	"originalContentLanguage": "en",
				// 	"position": {
				// 		"hr": "R&D Engineer @ Notch",
				// 		"en": "R&D Engineer @ Notch"
				// 	},
				// 	"bio": {
				// 		"hr": "Moji opći interesi nalaze se na presjeku računalnih znanosti i primijenjene matematike. Profesionalnu karijeru započeo sam u području obrade signala, nastavio s ugrađenim sustavima i IoT-om, a u novije vrijeme fokusiram se na umjetnu inteligenciju. Posebno me zanimaju razvoj agenata, prompt i kontekstno inženjerstvo te različiti optimizacijski procesi.",
				// 		"en": "My general interests are in the intersection of computer science and applied math. I've started my professional career with signal processing, continued with embedded, IoT and more recently AI. I am interested in agent development, prompt/context engineering as well as various kinds of optimization processes."
				// 	},
				// 	"social": {
				// 		"linkedIn": "https://www.linkedin.com/in/marco-hrli%C4%87-714501a1/"
				// 	}
				// },
				"slopko-bekavac-barbara": {
					"visible": true,
					"placeholder": false,
					"image": "barbara-slopko-bekavac.jpg",
					"name": "Barbara",
					"surname": "Slopko Bekavac",
					"contact": {
						"email": "slopkobarb@gmail.com"
					},
					"originalContentLanguage": "hr",
					"position": {
						"hr": "Owner @ Intuera",
						"en": "Owner @ Intuera"
					},
					"bio": {
						"hr": "I'm a UX researcher and designer specializing in e-commerce optimization and neuroscience-driven user experience. As the founder of Intuera, I combine UX, CRO, and behavioral science to uncover how people actually think, decide, and trust online. \r\nMy work explores how design decisions shape user behavior, influence purchase confidence, and reduce friction across the customer journey. By optimizing cognitive load, clarity, and interaction patterns, I help brands increase conversions while building long-term trust.",
						"en": "I'm a UX researcher and designer specializing in e-commerce optimization and neuroscience-driven user experience. As the founder of Intuera, I combine UX, CRO, and behavioral science to uncover how people actually think, decide, and trust online. \r\nMy work explores how design decisions shape user behavior, influence purchase confidence, and reduce friction across the customer journey. By optimizing cognitive load, clarity, and interaction patterns, I help brands increase conversions while building long-term trust."
					},
					"social": {
						"linkedIn": "https://www.linkedin.com/in/barbara-slopko/"
					}
				},
				"levacic-filip": {
					visible: true,
					placeholder: false,
					image: "levacic-filip.jpg",
					name: "Filip",
					surname: "Levačić",
					contact: {
						email: "levacic1995@gmail.com",
					},
					position: {
						hr: "Senior Software Developer @ Codebooq",
						en: "Senior Software Developer @ Codebooq",
					},
					bio: {
						hr: "An experienced software developer, from .NET backend, Angular and React frontend, to cloud and mobile. Loves working in large teams and knowledge sharing with his colleagues, mentoring students and doing both internal and conference talks. Loves units tests, readable code and interesting question at pub quizzes, even if he doesn't know the answer. Hates the trend of mentioning the Terminator in every discussion about AI.",
						en: "An experienced software developer, from .NET backend, Angular and React frontend, to cloud and mobile. Loves working in large teams and knowledge sharing with his colleagues, mentoring students and doing both internal and conference talks. Loves units tests, readable code and interesting question at pub quizzes, even if he doesn't know the answer. Hates the trend of mentioning the Terminator in every discussion about AI.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/filiplevacic/",
					},
				},
			},
			schedule: [
				{
					// registration
					duration: 60,
					special: true,
					doNotEvaluate: true,
					skipOnSurvey: true,
					// language: "en",
					title: {
						hr: "Registracija i kava",
						en: "Registration & coffee",
					},
					description: {
						hr: [],
						en: []
					}
				},
				{
					// opening ceremony
					duration: 10,
					special: true,
					doNotEvaluate: true,
					skipOnSurvey: true,
					// language: "en",
					title: {
						hr: "Otvaranje konferencije",
						en: "Conference opening",
					},
					description: {
						hr: [],
						en: []
					}
				},
				{
					session: "keynote-predavanje",
				},
				TRACK_BREAK(15),
				[
					{
						session: "agentic-ai-a-new-software-development-paradigm",
					},
					{
						session: "trikovi-koristi-i-tranzicije-kako-lideri-i-zaposlenici-percipiraju-umjetnu-inteligenciju-ui",
					},
					{
						session: "scared-excited-and-lost-a-compass-for-the-future-of-work"
					}
				],
				TRACK_BREAK(15),
				[
					{
						session: "jedna-cipela-za-24000-nogu-kako-dizajnirati-interni-enterprise-softver-koji-nikog-ne-zulja"
					},
					{
						session: "solution-architecture-in-the-ai-era"
					},
					{
						session: "going-by-the-book-and-failing"
					},
				],
				TRACK_BREAK(15),
				[
					{
						session: "from-vibes-to-production-deploying-ai-built-apps",
					},
					{
						session: "cloud-native-smart-transport-architecture-security-dev-lessons",
					},
					{
						session: "vise-ai-a-manje-tokena-optimiranjem-arhitekture-do-manjih-troskova",
					},
				],
				LUNCH_BREAK(75),
				[
					{
						session: "aiot-kada-inteligencija-dolazi-na-rub-mreze",
					},
					{
						session: "from-prompts-to-purpose-architecting-agentic-ai-in-the-azure-cloud",
					},
					{
						session: "deploy-without-drama-a-legal-framework-for-tech-teams",
					},
				],
				TRACK_BREAK(15),
				[
					{
						session: "who-needs-sql"
						// session: "reactive-apps-without-frameworks",
					},
					{
						session: "potentially-real-dangers-of-artificial-intelligence"
					},
					{
						session: "invisible-ux-the-interfaces-users-never-notice-but-always-miss",
					},
				],
				TRACK_BREAK(15),
				[
					{
						session: "from-atoms-to-units-rethinking-what-we-test",
					},
					{
						session: "net-iot-and-hedgehogs",
					},
					{
						session: "reinforcement-learning-prednosti-i-primjena-ove-grane-ai",
					},
				],
				{
					duration: 105,
					break: true,
					doNotEvaluate: true,
					showDuration: false,
					title: {
						hr: "Kraj konferencije",
						en: "Kraj konferencije",
					},
					// poweredBy: {
					// 	name: "cWebSpace"
					// }
				},
				// {
				// 	// speakers dinner
				// 	duration: 60,
				// 	special: true,
				// 	doNotEvaluate: true,
				// 	skipOnSurvey: true,
				// 	// language: "hr",
				// 	title: {
				// 		hr: "Večera za predavače",
				// 		en: "Speakers Dinner",
				// 	},
				// 	description: {
				// 		hr: [],
				// 		en: []
				// 	}
				// },
			],
			faq: {
				hr: [
					{
						title: "Što je Weblica?",
						short: "",
						full: "Weblica je konferencija posvećena web tehnologijama i IT sektoru koja okuplja različite stručnjake i entuzijaste iz cijele regije.",
					},
					{
						title: "Gdje i kada će se održati Weblica {{currentYear}}?",
						short: "",
						full: [
							"Weblica {{currentYear}} održat će se {{eventDate}} s početkom u {{eventTime}} sati.<br/>",
							"Adresa: {{venueNameAndAddress}}<br/><br/>",
							"Pronađi lokaciju <a href='{{mapUrl}}' target='_blank'>na ovoj karti</a>.",
						],
					},
					{
						title: "Kako se prijaviti za sudjelovanje kao predavač na Weblici i koji je rok za prijavu?",
						short: "",
						full: [
							`Prijave za predavače završavaju {{lectureRegistration.to}} u ponoć, a prijaviti se možete putem <a href='{{sessionsUrl}}' target='_blank'>Sessionize platforme</a>`,
						],
					},
					{
						title: "Koji su glavni sadržaji konferencije?",
						short: "",
						full: "Konferencija obuhvaća  razna predavanja, radionice i panel diskusije o najnovijim trendovima i temama u web tehnologijama.",
					},
					{
						title: "Koja je ciljna publika Weblice?",
						short: "",
						full: "Weblica okuplja stručnjake iz IT sektora, developere, programere, dizajnere, poduzetnike te sve koji su strastveni prema web tehnologijama.",
					},
					{
						title: "Kako mogu postati sponzor Weblice?",
						short: "",
						full: "Ako ste zainteresirani za sponzorstvo, pošaljite nam upit <a href='/{{linkLang}}/sponsors'>korištenjem ove forme.</a>",
					},
					{
						title: "Je li sudjelovanje na Weblici besplatno?",
						short: "",
						full: "Nažalost ne, ali cijene su iznimno pristupačne. Više informacija možete saznati na <a href='/{{linkLang}}/{{event}}/#tickets'>ovdje</a>.",
					},
					{
						title: "Trebam li imati tehničko predznanje za sudjelovanje na konferenciji?",
						short: "",
						full: "Weblica je namijenjena različitim razinama znanja, tako da i početnici i oni iskusniji mogu pronaći relevantne sadržaje.",
					},
					{
						title: "Kako mogu volontirati na konferenciji?",
						short: "",
						full: "Volonteri su i više nego dobro došli. Ako si zainteresiran(a) za sudjelovanje kao volonter, <a href='/{{linkLang}}/volunteer'>popuni ovu formu</a>.",
					},
					{
						title: "Hoće li negdje biti omogućeno parkirati automobil?",
						short: "",
						full: "Da, omogućen je besplatan parking.",
					},
				],
				en: [
					{
						title: "What is Weblica?",
						short: "",
						full: "Weblica is a conference dedicated to web technologies and the IT sector that brings together various experts and enthusiasts from the entire region.",
					},
					{
						title: "Do I need to have technical background to participate?",
						short: "",
						full: "Our conference is designed for attendees of all knowledge levels. We select sessions that are accessible to a broader audience, but also include advanced topics for more experienced participants. Each session is labeled with the required knowledge level, so you’ll know in advance if it’s beginner-friendly or more suited to experts.",
					},
					{
						title: "Where and when will Weblica {{currentYear}} be held?",
						short: "",
						full: [
							"<p>Weblica {{currentYear}} will be held on <b>{{eventDate}}</b>, starting at {{eventTime}}.<br/>",
							"It will be held at <a href='/{{event}}/{{linkLang}}#venue'><b>{{venueName}}</b></a><b>, {{venueAddress}}</b>.</p>",
						],
					},
					{
						title: "How to apply for participation as a speaker and what is the application deadline?",
						short: "",
						full: `Applications for speakers end on {{lectureRegistration.to}} at midnight, and you can register via <a href='{{sessionsUrl}}' target='_blank'>Sessionize platform</a>`,
					},
					{
						title: "What is the target audience?",
						short: "",
						full: "Weblica brings together experts from the IT sector, developers, programmers, designers, entrepreneurs and everyone who is passionate about web technologies.",
					},
					{
						title: "How can I become a sponsor?",
						short: "",
						full: "If you are interested in sponsorship, please send us an inquiry <a href='{{urlPrefix}}/{{linkLang}}/sponsors'>using this form.</a>",
					},
					{
						title: "How can I volunteer at the conference?",
						short: "",
						full: "Volunteers are more than welcome. If you are interested in participating, please <a href='{{urlPrefix}}/{{linkLang}}/volunteer'>use this form</a>.",
					},
					{
						title: "Is participation free of charge?",
						short: "",
						full: "Unfortunately not. <a href='{{urlPrefix}}/{{linkLang}}/{{event}}/#tickets'>Check out the tickets</a>",
					},
					{
						title: "Can I get a refund if I can not longer attend?",
						short: "",
						full: "No, we do not provide refunds, but we can authorize ticket transfer.<br/>Please contact us at <a href='mailto:info@weblica.hr' targget='_blank'>info@weblica.hr</a>.",
					},
					// {
					// 	title: "How can I access Worklica workshops?",
					// 	short: "",
					// 	full: [
					// 		"All Weblica tickets give you access to workshops, but you need to register in order to secure your spot on specific workshop(s)."
					// 	]
					// },
					{
						title: "Will it be possible to park a car somewhere?",
						short: "",
						full: "Yes, free parking is available.",
					},
					// {
					// 	title: "x",
					// 	short: "",
					// 	full: ""
					// },
				],
			},
			news: {
				en: [
					{
						title: "Info",
						when: "2026-05-13",
						startDate: "2026-05-13 00:00:00",
						endDate: "2026-05-14 23:59:59",
						breaking: true,
						full: [`
							<p>
              Tomorrow, the entire tech community of the region gathers again at Weblica.
                <ul class='specBoxList'>
                  <li>Developers.</li>
                  <li>Designers.</li>
                  <li>Leaders.</li>
                  <li>Students.</li>
                  <li>Company founders.</li>
                  <li>And people who simply love technology.</li>
                </ul>
              </p>
              <p>
                And honestly - we can't wait for everything to start. 💙
              </p>
              <p>
              Weblica 2026 is officially sold out, and we are especially glad that the conference has remained small enough that you will actually be able to meet people - without the crowds, without awkward networking, and without "speed dating" conversations.
              </p>
              <p>
                Important information before your arrival:
                <ul class='specBoxList'>
                  <li>📍 Terme Sveti Martin</li>
                  <li>🕗 Registration: from 07:50</li>
                  <li> 🎤 Conference opening: 08:50</li>
                </ul>
              </p>
              <p>
                Registration is divided into 2 points:
                <ul class='specBoxList'>
                  <li>A - K</li>
                  <li>L - Ž</li>
                </ul>
              </p>
              <p>
                We expect the biggest rush between 08:25 and 08:45, so we recommend arriving between 08:00 and 08:20.
              </p>
              <p>
                <h3>Parking</h3>
                Parking at the hotel is free, but it can fill up quickly.<br/>
                Additional spaces are available:
                <ul class='specBoxList'>
                  <li>near the pool entrance</li>
                  <li>near Pub Potkova</li>
                </ul>
              </p>
              <p>
              <h3>What awaits you?</h3>
              <ul class='specBoxList'>
                <li>19 lectures</li>
                <li>3 tracks</li>
                <li>concrete practical experiences</li>
                <li>lunch, coffee, and snacks</li>
                <li>and one very great group of people</li>
              </ul>
							<p>
              	See you tomorrow. 💙
							</p>
						`],
					}
				],
				hr: [
					{
						title: "Info",
						when: "2026-05-13",
						startDate: "2026-05-13 00:00:00",
						endDate: "2026-05-14 23:59:59",
						breaking: true,
						full: [`
							<p>
							Sutra se na Weblici ponovno okuplja cijela tech zajednica regije.
								<ul class='specBoxList'>
									<li>Developeri.</li>
									<li>Dizajneri.</li>
									<li>Lideri.</li>
									<li>Studenti.</li>
									<li>Osnivači firmi.</li>
									<li>I ljudi koji jednostavno vole tehnologiju.</li>
								</ul>
							</p>
							<p>
								I iskreno - jedva čekamo da sve krene. 💙
							</p>
							<p>
							Weblica 2026 službeno je rasprodana, a posebno nam je drago što je konferencija ostala dovoljno mala da ćete ljude stvarno moći upoznati - bez mase, bez awkward networkinga i bez “speed dating” razgovora.
							</p>
							<p>
								Važne informacije prije dolaska:
								<ul class='specBoxList'>
									<li>Terme Sveti Martin</li>
									<li>Registracija: od 07:50</li>
									<li>Otvaranje konferencije: 08:50</li>
								</ul>
							</p>
							<p>
								Registracija je podijeljena na 2 punkta:
								<ul class='specBoxList'>
									<li>A - K</li>
									<li>L - Ž</li>
								</ul>
							</p>
							<p>
								Najveću gužvu očekujemo između 08:25 i 08:45 pa preporučujemo dolazak između 08:00 i 08:20.
							</p>
							<p>
								<h3>Parking</h3>
								Parking kod hotela je besplatan, ali se može brzo popuniti.<br/>
								Dodatna mjesta dostupna su:
								<ul class='specBoxList'>
									<li>kod ulaza na bazene</li>
									<li>kod Puba Potkova</li>
								</ul>
							</p>
							<p>
							<h3>Što vas čeka?</h3>
							<ul class='specBoxList'>
								<li>19 predavanja</li>
								<li>3 tracka</li>
								<li>konkretna iskustva iz prakse</li>
								<li>ručak, kava i grickalice</li>
								<li>i jedna jako dobra ekipa ljudi</li>
							</ul>
							<p>
								Vidimo se sutra.
							</p>
						`],
					}
				],
			},
			testimonials: [ // TODO (low) - add selected testimonials from 2026 survey
				// {
				// 	text: {
				// 		hr: [],
				// 		en: [
				// 			"<p>Honestly i was surprised with the quality! No BS sales, a lot of actionable tips, great speakers, always a follow up question from the crowd</p>"
				// 		]
				// 	}
				// },
				{
					speaker: true,
					name: "Frank",
					description: {
						hr: "Data Architect",
						en: "Data Architect",
					},
					text: {
						hr: [
							'<p>The tangible "startup energy", crowd enthusiasm, and passion for engagement with all the participants was a real boost for me. While a lot of the content was in Croatian, everyone I talked to in groups and in person made an effort to communicate in English (and a bit of German!). The food, weather and setting were also wonderful!! I look forward to following your growth and returning again next year!</p>',
						],
						en: [
							'<p>The tangible "startup energy", crowd enthusiasm, and passion for engagement with all the participants was a real boost for me. While a lot of the content was in Croatian, everyone I talked to in groups and in person made an effort to communicate in English (and a bit of German!). The food, weather and setting were also wonderful!! I look forward to following your growth and returning again next year!</p>',
						],
					},
				},
				{
					name: "Ivan",
					description: {
						hr: "developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Na Weblici sam naučio puno novih i korisnih stvari koje koristim svakoga dana, a osim predavanja - ekipa i hrana su super. </p>",
						],
						en: [
							"<p>At Weblica, I learned many new and useful things that I use every day, and besides the lectures - the team and the food are great.</p>",
						],
					},
				},
				{
					speaker: true,
					name: "Marko",
					description: {
						hr: "developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Weblica je sinonim za vrhunske predavače,najnovije trendove u IT-u, pregršt zabave i druženje s kolegama. Zato obavezno stavite Weblicu u vaš kalendar i vidimo se u svibnju u Čakovcu.</p>",
						],
						en: [
							"<p>Weblica is synonymous with top-notch speakers, the latest trends in IT, loads of fun, and networking with colleagues. That's why you should definitely put Weblica in your calendar and see you in May in Čakovec.</p>",
						],
					},
				},
				{
					speaker: true,
					name: "Tomislav",
					description: {
						hr: "Dizajner",
						en: "Designer",
					},
					text: {
						hr: [
							"<p>Weblica je jedno predivno iskustvo jer su prisutni ljudi poput vas, ljudi koji rade isti posao i koji su uspjeli u karijeri koju svi dijelimo. Može se jako puno naučiti iiz predavanja, ali i direktne komunikacije s predavačima jer to nisu neki tamo eterični ljudi iz cijelog svijeta - to su ljudi iz naše okoline koji znaju svoj posao. Mislim da je Weblica super prilika za naučiti nešto novo i napredovati u svojoj karijeri.</p>",
							"<p>Ekipa koja organizira Weblicu, koja stoji iza nje, je zakon. Atmosfera je fantastična i vidi se da ljudi rade sa strašću. Preporučam konferenciju svakome, neće faliti ni dobre zabave, ni hrane, a ni pića.</p>",
						],
						en: [
							"<p>Weblica is one marvelous experience because it is attended by people like you, people who do the same job and who have succeeded in the career we all share. There's so much to learn not only from the lectures but also from direct communication with the speakers because they aren't just some ethereal people from around the world - they are people from our environment who know their job. I think Weblica is a great opportunity to learn something new and advance in your career.</p>",
							"<p>The team organizing Weblica, who stands behind it, is awesome. The atmosphere is fantastic and you can see that people work with passion. I recommend the conference to everyone, there will be no shortage of good fun, food, or drinks.</p>",
						],
					},
				},
				{
					name: "Kristina",
					description: {
						hr: "Developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Weblica 2024 bila je vrlo zanimljivo iskustvo. Predavanja kojima sam se pridružila bile su stvarno informativne. Potvrdila sam neke stvari koje sam već znala i naučila puno novih ideja. Iskreno, hrana je bila puno bolja nego što sam očekivala. Dobra raznolikost, i nisam otišla gladna.</p>",
						],
						en: [
							"<p>Weblica 2024 was a very interesting experience. The sessions I joined were really informative. I confirmed some things I already knew and learned a lot of new ideas. Honestly, the food was way better than I expected. Good variety, and I didn’t go hungry.</p>",
						],
					},
				},
				{
					name: "Davor",
					description: {
						hr: "Developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Na Weblicu dolazim od njenog drugog izdanja, i od tad sam stalni član i posjetitelj ovog eventa. Po mojem, ovo je najbolji event u ovoj regiji, što se tiče programske i dizajnerske industrije. Vidimo se na druženju uz pive i ostalo.</p>",
						],
						en: [
							"<p>I have been coming to Weblica since its second edition. In my opinion, this is the best event in this region regarding the programming and design industry. Hope to see you at the gathering with beers and the rest.</p>",
						],
					},
				},
				{
					name: "Viktor",
					description: {
						hr: "Developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Na Weblicu se vraćam svake godine. Sviđa mi se networking, druženje s ljudima, super je ekipa i super su predavanja. Bilo bi mi drago da ima više tema vezanih uz Java programiranje.</p>",
						],
						en: [
							"<p>I come to Weblica every year. I like networking and socializing with people, the team is great and so are the lectures. I would be glad if there were more topics related to Java programming.</p>",
						],
					},
				},
				{
					name: "Nikola",
					description: {
						hr: "Developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Weblicu pratim od 2019., a 2024. mi je bila najbolja do sada. Mjesto je bilo dobro, a dvije paralelne staze olakšale su odabir sesija koje su mi odgovarale. Neke su se sesije mogle malo dublje pozabaviti temom, ali sve u svemu, svakako je vrijedilo posjetiti. I, naravno, druženje s momcima iz industrije učinilo ga je još posebnijim i nezaboravnijim.</p>",
						],
						en: [
							"<p>I've attended Weblica since 2019, and the 2024 one was the best so far. The venue was good, and having two parallel tracks made it easy to pick sessions that suited me. Some sessions could have gone a bit deeper into the subject, but overall, it was definitely worth the visit. And, of course, catching up with fellas from the industry made it all the more special and memorable.</p>",
						],
					},
				},
			],
			extraContent: [],
		},
		hacklica: {
			config: { // override config.js setup - disable this event for year 2026
				enabled: false,
				active: false,
				visible: false,
				visibleInHeader: false,
			},
			startDateTime: null, // "2025-05-03 08:00:00",
			endDateTime: null, // "2025-05-04 08:00:00",
			specialDates: {
				demos: null,
				winningCeremony: null,
			},
			prizeAmounts: [5000, 3000, 1500],
			menuItems: {
				about: {
					menu: "About",
					url: "/hacklica#about",
					visible: false,
				},
				news: {
					menu: "News",
					url: "/hacklica#news",
					visible: false,
				},
				topics: {
					menu: "Topics",
					url: "/hacklica#topics",
					visible: false,
				},
				venue: {
					menu: "Venue",
					url: "/hacklica#venue",
					visible: false,
				},
				faq: {
					menu: "FAQ",
					url: "/hacklica#faq",
					visible: false,
				},
				sponsors: {
					menu: "Sponsors",
					url: "/hacklica#sponsors",
					visible: false,
				},
				terms: {
					menu: "Terms",
					url: "/hacklica/terms",
					special: true,
					visible: false,
				},
				policy: {
					menu: "Policy",
					url: "/hacklica/policy",
					special: true,
					visible: false,
				},
			},
			buttons: {
				register: {
					title: "Register your team",
					url: "/hacklica/register",
					hollow: true,
					dateLimit: "teamRegistration",
					visible: false,
				},
			},
			forcedButtons: {
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: false,
					dateLimit: "sponsorRegistration",
				},
			},
			sections: {
				hero: {
					visible: true,
					bgImage: "/media/WEBLICA_banner_1920x1080.png",
					// introImage: {
					// 	img: "hacklica-2019-2.jpg",
					// 	alt: "Hacklica 2019",
					// },
					// introVideo: [
					// 	{
					// 		media: "(max-width: 640px)",
					// 		url: "/media/WEBLICA_banner_animation_640x360.mp4",
					// 		poster: "/media/WEBLICA_banner_1280x720.png",
					// 		type: "video/mp4",
					// 	},
					// 	{
					// 		media: "(max-width: 1280px)",
					// 		url: "/media/WEBLICA_banner_animation_1280x720.mp4",
					// 		poster: "/media/WEBLICA_banner_1280x720.png",
					// 		type: "video/mp4",
					// 	},
					// 	{
					// 		media: "(min-width: 1281px)",
					// 		url: "/media/WEBLICA_banner_animation_1920x1080.mp4",
					// 		poster: "/media/WEBLICA_banner_1920x1080.png",
					// 		type: "video/mp4",
					// 	},
					// ],
					blocks: [],
				},
				about: {
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "hacklica-2019-3.jpg",
								alt: "Hacklica 2019",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
					],
				},
				news: {
					visible: false,
				},
				topics: {
					visible: true,
				},
				venue: {
					visible: true,
				},
				faq: {
					visible: true,
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
				testimonials: {
					visible: false,
				},
				historyGallery: {
					visible: true,
				},
			},
			__venue: {
				name: {
					hr: "Graditeljska škola",
					en: "School of Architecture",
				},
				nameAlt: {
					hr: "Dvorana Graditeljske škole",
					en: "Hall of the School of Architecture",
				},
				street: "Športska ulica 1",
				postalCode: "40000",
				city: "Čakovec",
				country: "Croatia",
				countryShort: "HR",
				leaflet: {
					location: [46.38921, 16.42269],
					zoom: 19,
				},
				mapUrl:
					"https://www.google.com/maps/place/Graditeljska+%C5%A1kola+%C4%8Cakovec/@46.3888122,16.4220393,15z/data=!4m5!3m4!1s0x0:0x129b433371a3c66f!8m2!3d46.3888122!4d16.4220399",
				mapImage: "gsc-dvorana-map.png",
				images: ["gsc-dvorana-1.jpeg", "gsc-dvorana-2.jpeg"],
			},
			__faq: {
				hr: [
					{
						title: "HR-HH-faq 1",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 2",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 3",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 4",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 5",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 6",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 7",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 8",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
				en: [
					{
						title: "EN-What is the smallest or the largest team size?",
						short:
							"Minimum is 2 members (as you probably expected) and the largest team can have up to 6 members. Everything in between is fine by us.",
						full: "Minimum is 2 members (as you probably expected) and the largest team can have up to 6 members. Everything in between is fine by us.",
					},
					{
						title: "Can we base our work on preexisting work of ours?",
						short: "Short answer would be-no! But ...",
						full: "If your team has some utilities or smaller libraries that can aid you, yes, you can use that. But beware! We will check the code (it is part of judging process) and we will disqualify full teams if we notice that code volume is not consistent with what is possible in 24 hour window. You will be able to speak up of course if such event occurs, but we are all seniors here and can not be fooled so easily!",
					},
					{
						title: "faq 3",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 4",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
			},
			__news: {
				hr: [
					{
						title: "HR-HH-here we go again",
						when: "2021-09-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "HH-here we go again #2",
						when: "2021-09-03 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "",
					},
					{
						title: "HH-full steam ahead",
						when: "2021-11-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HH-tickets are ready-go go go",
						when: "2024-01-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
				en: [
					{
						title: "EN-HH-here we go again",
						when: "2021-09-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "HH-here we go again #2",
						when: "2021-09-03 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "",
					},
					{
						title: "HH-full steam ahead",
						when: "2021-11-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HH-tickets are ready-go go go",
						when: "2024-01-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
			},
			__topics: {
				hr: [
					{
						title: "HR topic 1",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HR topic 2",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HR topic 3",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
				],
				en: [
					{
						title: "EN topic 1",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "EN topic 2",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "EN topic 3",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
				],
			},
		},
		worklica: {
			config: { // override config.js setup - disable this event for year 2026
				enabled: false,
				active: false,
				visible: false,
				visibleInHeader: false,
			},
			// previewMode: ["schedule"],
			// workInProgress: ["speakers", "schedule"],
			tracks: ["track1"],
			externalLinks: EXTERNAL_LINKS,
			startDateTime: "2026-05-08 10:10:00",
			endDateTime: "2026-05-08 23:59:59",
			options: {
				entrioEventID: "25646",
				enableWorkshopRegistration: true
			},
			menuItems: {
				about: {
					menu: "About",
					url: "/worklica#about",
					visible: false,
				},
				news: {
					menu: "News",
					url: "/worklica#news",
					visible: false,
				},
				speakers: {
					menu: "Speakers",
					url: "/worklica#speakers",
					visible: true,
				},
				schedule: {
					menu: "Schedule",
					url: "/worklica#schedule",
					visible: true,
				},
				tickets: {
					menu: "Tickets",
					url: "/worklica#tickets",
					visible: false,
				},
				venue: {
					menu: "Venue",
					url: "/worklica#venue",
					visible: "active,before",
				},
				faq: {
					menu: "FAQ",
					url: "/worklica#faq",
					visible: "active,before",
				},
				sponsors: {
					menu: "Sponsors",
					url: "/worklica#sponsors",
					visible: true,
				},
			},
			buttons: {
				register: {
					title: "Register a workshop",
					url: EXTERNAL_LINKS.sessions,
					hollow: true,
					external: true,
					visible: false,
					visibleOnHero: true,
					wide: true,
					// full: true,
					dateLimit: "workshopRegistration",
				},
				tickets: {
					title: "Get Tickets",
					url: "/worklica#tickets",
					hollow: false,
					external: false,
					visible: false, // XXX - true,
					dateLimit: "ticketSales.worklica",
					//---
					visibleOnHero: false, // XXX - true,
					hollowOnHero: true,
					extraClassesOnHero: ["showOnSmall"],
					// ---
					floatingSpecial: {
						// if defined, it will override given when on floating menu - this jumps directly to Entrio instead of to #tickets section
						url: EXTERNAL_LINKS.tickets,
						external: true,
					},
				},
			},
			forcedButtons: {
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: true,
					linkInFooter: true,
					dateLimit: "sponsorRegistration",
				},
			},
			sections: {
				hero: {
					visible: true,
					bgImage: "/media/WEBLICA_banner_1920x1080.png",
					introImage: {
						// img: "WEBLICA_banner_1280x720.png",
						img: "Worklica 2025 (9).jpg",
						alt: "Hero Image",
					},
					// introImageRandom: [
					// 	{
					// 		img: "WEBLICA_banner_1280x720.png",
					// 		alt: "Worklica 2025",
					// 	},
					// 	{
					// 		img: "Worklica 2025 (28).jpg",
					// 		alt: "Worklica 2025",
					// 	},
					// 	{
					// 		img: "Worklica 2025 (9).jpg",
					// 		alt: "Worklica 2025",
					// 	},
					// 	{
					// 		img: "Worklica 2025 (21).jpg",
					// 		alt: "Worklica 2025",
					// 	},
					// 	{
					// 		img: "Worklica 2025 (247).jpg",
					// 		alt: "Worklica 2025",
					// 	},
					// ],
					// introVideo: [
					// 	{
					// 		media: "(max-width: 640px)",
					// 		url: "/media/WEBLICA_banner_animation_640x360.mp4",
					// 		poster: "/media/WEBLICA_banner_1280x720.png",
					// 		type: "video/mp4",
					// 	},
					// 	{
					// 		media: "(max-width: 1280px)",
					// 		url: "/media/WEBLICA_banner_animation_1280x720.mp4",
					// 		poster: "/media/WEBLICA_banner_1280x720.png",
					// 		type: "video/mp4",
					// 	},
					// 	{
					// 		media: "(min-width: 1281px)",
					// 		url: "/media/WEBLICA_banner_animation_1920x1080.mp4",
					// 		poster: "/media/WEBLICA_banner_1920x1080.png",
					// 		type: "video/mp4",
					// 	},
					// ],
					blocks: [],
				},
				about: {
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "Worklica 2025 (12).jpg",
								alt: "Worklica 2025",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
						{
							width: "half",
							text: "txt_bbb",
						},
						{
							width: "half", // full || half
							image: {
								file: "Worklica 2025 (20).jpg",
								alt: "Worklica 2025",
							},
						},
					],
				},
				news: {
					visible: false,
				},
				speakers: {
					visible: true,
				},
				schedule: {
					visible: true,
				},
				venue: {
					visible: true,
				},
				tickets: {
					visible: false, // XXX - true,
				},
				faq: {
					visible: true,
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
				testimonials: {
					visible: false,
				},
				historyGallery: {
					visible: true,
				},
			},
			venue: {
				venue: "terme-sveti-martin",
			},
			tickets: [],
			speakers: {},
			sessions: [],
			sessionAssets: [],
			schedule: [],
			faq: {
				hr: [],
				en: [
					{
						title: "Who is Worklica for?",
						short: "",
						full: "Worklica is designed for developers who want to explore technical challenges and solutions in greater detail. Unlike conference sessions, workshops offer more time to dig deeper into specific topics, sometimes requiring active participation. Each workshop will indicate whether hands-on involvement is expected.",
					},
					{
						title: "Do I need to have technical background to participate?",
						short: "",
						full: "The required knowledge level for each workshop depends on the topic. Some workshops will dive deep into technical subjects, while others may be more accessible to beginners. Each workshop will clearly state the knowledge level required, so you can choose the ones that best fit your experience.",
					},
					{
						title: "Where and when will Worklica {{currentYear}} be held?",
						short: "",
						full: [
							"<p>Worklica {{currentYear}} will be held on <b>{{eventDate}}</b>, starting at {{eventTime}}.<br/>",
							"It will be held at <a href='/{{event}}/{{linkLang}}#venue'><b>{{venueName}}</b></a><b>, {{venueAddress}}</b>.</p>",
							// "It will be held at <a href='{{mapUrl}}' target='_blank'><b>{{venueNameAndAddress}}</b></a>.</p>",
						],
					},
					{
						title: "How to apply for participation as a lecturer and what is the application deadline?",
						short: "",
						full: `Applications for speakers end on {{workshopRegistration.to}} at midnight, and you can register via <a href='{{sessionsUrl}}' target='_blank'>Sessionize platform</a> (please notice Session type entry).`,
					},
					{
						title: "How can I become a Worklica sponsor?",
						short: "",
						full: "If you are interested in sponsorship, please send us an inquiry <a href='{{urlPrefix}}/{{linkLang}}/sponsors'>using this form.</a>",
					},
					{
						title: "Is participation free of charge?",
						short: "",
						full: "Unfortunately not. <a href='{{urlPrefix}}/{{linkLang}}/{{event}}/#tickets'>Check out the tickets</a>",
					},
					{
						title: "Can I get a refund if I can not longer attend?",
						short: "",
						full: "No, we do not provide refunds, but we can authorize ticket transfer.<br/>Please contact us at <a href='mailto:info@weblica.hr' targget='_blank'>info@weblica.hr</a>.",
					},
					{
						title: "Will it be possible to park a car somewhere?",
						short: "",
						full: "Yes, free parking is available.",
					},
					// {
					// 	title: "x",
					// 	short: "",
					// 	full: ""
					// },
				],
			},
			news: {
				hr: [],
				en: [],
			},
			extraContent: [],
		},
	},
	tickets: [ // generic tickets - this data is used ONLY if event-specific tickets are not defined
		// {
		// 	ident: "student",
		// 	// soldOut: true, // for manual control - if true, ticket count is ignored
		// 	ticketingSystem: {
		// 		maxAvailable: 25,
		// 		categoryName: "Student",
		// 	},
		// 	icon: "student",
		// 	title: {
		// 		hr: "Student",
		// 		en: "Student",
		// 	},
		// 	remark: {
		// 		hr: "",
		// 		en: "Your status will be checked at entry!"
		// 	},
		// 	price: 24,
		// 	listed: true,
		// 	available: true,
		// 	limited: true,
		// 	// special: true,
		// 	startDate: "2025-06-01",
		// 	endDate: "2026-05-08 08:00:00",
		// 	access: {
		// 		conference: true,
		// 		workshops: true,
		// 		snacks: true,
		// 		three_meals: true,
		// 		chill_zone: true,
		// 		after: true,
		// 		goodies: true,
		// 		extra_madjerka: true,
		// 		extra_supporter: false,
		// 	},
		// },
		// {
		// 	ident: "early",
		// 	ticketingSystem: {
		// 		maxAvailable: 50,
		// 		categoryName: "Early",
		// 	},
		// 	icon: "clock",
		// 	title: {
		// 		hr: "Early",
		// 		en: "Early",
		// 	},
		// 	// remark: {
		// 	// 	hr: "",
		// 	// 	en: "Get this one and pay half the price!"
		// 	// },
		// 	price: 60,
		// 	listed: true,
		// 	available: true,
		// 	limited: true,
		// 	// special: false,
		// 	startDate: "2025-06-01",
		// 	endDate: "2025-10-31 23:59:59",
		// 	access: {
		// 		conference: true,
		// 		workshops: true,
		// 		snacks: true,
		// 		three_meals: true,
		// 		chill_zone: true,
		// 		after: true,
		// 		goodies: true,
		// 		extra_madjerka: true,
		// 		extra_supporter: false,
		// 	},
		// },
		// {
		// 	ident: "mini_sponsor",
		// 	ticketingSystem: {
		// 		maxAvailable: 50,
		// 		categoryName: "Mini Sponsor",
		// 	},
		// 	icon: "friend",
		// 	title: {
		// 		hr: "",
		// 		en: "Mini Sponsor",
		// 	},
		// 	remark: {
		// 		hr: "",
		// 		en: "If you want to show extra support, and get some extra perks at the event, this is a ticket for you!"
		// 	},
		// 	price: 120,
		// 	listed: true,
		// 	available: true,
		// 	limited: true,
		// 	special: true,
		// 	startDate: "2025-06-01",
		// 	endDate: "2025-10-31 23:59:59",
		// 	access: {
		// 		conference: true,
		// 		workshops: true,
		// 		snacks: true,
		// 		three_meals: true,
		// 		chill_zone: true,
		// 		after: true,
		// 		goodies: true,
		// 		extra_madjerka: true,
		// 		extra_supporter: true,
		// 	},
		// },
		{
			ident: "regular",
			ticketingSystem: {
				maxAvailable: 250,
				categoryName: "Regular",
			},
			icon: "standard",
			title: {
				hr: "Regular",
				en: "Regular",
			},
			// remark: {
			// 	hr: "",
			// 	en: ""
			// },
			// description: {
			// 	hr: "",
			// 	en: ""
			// },
			description_below: {
				blocks: [
					{
						width: "twoThirds",
						text: {
							hr: [
								"<h3>Smještaj</h3>",
								"<p>Za posjetitelje Weblice su dostupne posebne cijene:</p>",
								"<ul>",
								"<li>Standardna jednokrevetna soba - <b>95€</b></li>",
								"<li>Standardna dvokrevetna soba - <b>120€</b></li>",
								"<li>Pristup wellnessu - <b>15€</b></li>",
								"<li>Bazeni \"Temple of Life\" - <b>10€</b></li>",
								"</ul>",
								"<br/>",
								"<p>* dodatno se naplaćuje boravišna pristojba u iznosu od 2€/dan/osoba</p>",
								"<p><b>Važno</b>: Za rezervaciju smještaja potrebno je imati kupljenu ulaznicu za Weblicu 2026.",
								"Nakon kupnje ulaznice, molimo Vas da nam se javite na <a href='mailto:info@weblica.hr'>info@weblica.hr</a> kako bismo Vam poslali poveznicu za rezervaciju smještaja.</p>"
							],
							en: [
								"<h3>Accomodation</h3>",
								"<p>Special rates available for Weblica atendees:</p>",
								"<ul>",
								"<li>Standard single room - <b>95€</b></li>",
								"<li>Standard double room - <b>120€</b></li>",
								"<li>Wellness access - <b>15€</b></li>",
								"<li>\"Temple of Life\" pools - <b>10€</b></li>",
								"</ul>",
								"<br/>",
								"<p><b>Important</b>: To get the special rate, you will need a valid Weblica ticket!</p>"
							],
						},
					},
					{
						width: "third",
						gallery: [
							{
								img: "terme_sv_martin_1.jpg",
							},
							{
								img: "terme_sv_martin_2.jpg",
							},
							{
								img: "terme_sv_martin_3.jpg",
							},
							{
								img: "terme_sv_martin_4.jpg",
							},
						],
					}
				],
			},
			price: 60,
			listed: true,
			available: true,
			startDate: "2025-11-01",
			endDate: "2026-05-08 23:59:59",
			access: {
				conference: true,
				// workshops: true,
				snacks: true,
				lunch: true,
				// three_meals: true,
				// chill_zone: true,
				// after: true,
				goodies: true,
				// extra_madjerka: true,
				// extra_supporter: false,
			},
		},
	],
	news: {
		// generic - show on all events - this data comes after event-specific items generating combined data
		hr: [],
		en: [],
	},
	faq: {
		// generic - show on all events - this data comes after event-specific items generating combined data
		hr: [],
		en: [
			// {
			// 	title: "Generic FAQ Entry #1",
			// 	short: "",
			// 	full: "Does this work? If so, this will be visible!",
			// },
		],
	},
	venues: [
		// generic venues - for easy reuse
		// {
		{
			ident: "terme-sveti-martin",
			name: {
				hr: "Terme Sveti Martin",
				en: "Terme Sveti Martin",
			},
			nameAlt: {
				hr: "Terme Sveti Martin",
				en: "Terme Sveti Martin",
			},
			street: "Izvorska 3",
			postalCode: "40313",
			city: "Sveti Martin Na Muri",
			country: "Croatia",
			countryShort: "HR",
			mapImage: "terme-location.png",
			mapUrl:
				"https://maps.app.goo.gl/wWQFnu7iGn3KbkCG7",
			images: [
				{
					// title: "Zgrada Doma kulture",
					img: "terme-0.jpg",
				},
				{
					// title: "Zgrada Doma kulture",
					img: "terme-1.jpg",
				},
				{
					// title: "Zgrada Doma kulture",
					img: "terme-2.jpg",
				},
				{
					// title: "Zgrada Doma kulture",
					img: "terme-3.jpg",
				}
			],
		}
	],
	sponsors: {
		l5: [
			{
				name: "Alma Career",
				url: "https://www.almacareer.com/hr",
				linkedIn: "https://www.linkedin.com/company/alma-career-croatia/",
				logo: "AC_Secondary_RGB_Transparent.svg",
				tags: [
					"WebDevelopment", "PHP", "Symfony", "JavaScript", "React", "AI", "PlatformDevelopment", "AWS", "DesignSystem"
				],
				description: {
					"hr": [
						"<p>Jednom riječju - povezujemo. Prave ljude s pravim kompanijama.</p>",
						"<p>Mi smo međunarodna tehnološka grupacija čiji proizvodi unapređuju svijet rada u devet europskih zemalja.</p>",
						"<p>U Češkoj nas možda poznajete po proizvodima kao što su Jobs.cz, Prace.cz, Prace za rohem, Atmoskop, Seduo, Arnold i drugi.</p>",
						"<p>U Slovačkoj smo prisutni kroz Profesia, ProfesiaDays, EduJobs, Platy.sk i druge platforme.</p>",
						"<p>Naša vizija je kontinuirano razvijati najbolja rješenja za kandidate, kompanije, obrazovanje i zadovoljstvo zaposlenika.</p>",
						"<p>Želite saznati više o nama? Svratite do našeg tea rooma na Weblici 2026!</p>"
					],
					"en": [
						"<p>In one word, we connect... the right people with the right companies.</p>",
						"<p>We are an international technology group whose products enhance the world of work across nine European countries.</p>",
						"<p>In the Czech Republic you may know our products, such as Jobs.cz, Prace.cz, Prace za rohem, Atmoskop, Seduo, Arnold and more.</p>",
						"<p>In Slovakia, you may know Profesia, ProfesiaDays, EduJobs, Platy.sk and more.</p>",
						"<p>Our vision is to consistently deliver the best solutions for candidates, companies, education, and employee satisfaction.</p>",
						"<p>Do you want to know more about us? Come to our tea-room at Weblica 2026!</p>"
					],
				}
			},
			{
				name: "cWebSpace",
				url: "https://cwebspace.hr",
				logo: "cwebspace-wt.svg",
				linkedIn: "https://www.linkedin.com/company/cwebspace",
				tags: ["SaaS", "CustomSoftwareDevelopment", "AI", "Biletra", "EnterpriseTicketingSolution"],
				description: {
					hr: [
						"<p>cWebSpace d.o.o. razvija custom softverska rješenja na cloud tehnologijama, s naglaskom na dugoročnu održivost i stvarnu vrijednost za korisnike.</p>",
						"<p>Osim rada s klijentima, aktivno gradimo i vlastite SaaS proizvode.</p>"
					],
					en: [
						"<p>cWebSpace d.o.o. develops custom software solutions built on cloud technologies, with a strong focus on long-term sustainability and delivering real value to users.</p>",
						"<p>In addition to working with clients, we actively build and develop our own SaaS products.</p>"
					]
				},
				extraStyle: {
					maxWidth: "90%"
				}
			},
			{
				name: "EBCONT",
				url: "https://www.ebcont.com/en",
				logo: "ebcont-base-inverted.png",
				tags: [
					"Analisys & Consulting", "AI, Big Data & Search", "UX/UI Design", "Development", "Infrastructure & Operations", "Quality Assurance", "Publishing"
				],
				description: {
					hr: "",
					en: "EBCONT is a leading Austrian IT services company with more than 700 employees that offers IT solutions for more than 130 customers from across all industries including the public sector. Covering the whole IT lifecycle, EBCONT also has an experienced team of AI and Data Science specialists, who employ state-of-the-art approaches and technologies in our customer projects."
				}
			},
			{
				name: "Factory X",
				url: "https://factory-x.hr",
				linkedIn: "https://www.linkedin.com/company/factory-x-d-o-o",
				logo: "factory-x-logo.svg",
				tags: [
					"Web Development",
					"Machine Learning",
					"Databases",
					"Graph databases",
					"DevOps",
					"Dynamics 365",
					"Business solutions",
				],
				description: {
					hr: [
						"<p>U Factory X smo specijalizirani za kreiranje prilagođenih softverskih rješenja za industrije kao što su obrazovanje, financije, medicina, zapošljavanje i šire. Naš fokus je na izgradnji dugoročnih partnerstava i isporuci prilagođenih rješenja koja pokreću uspjeh.</p>",
						"<p>Od savjetovanja i prikupljanja zahtjeva do dizajna, razvoja i podrške, mi se brinemo za sve. Naša inovativna, sigurna i skalabilna rješenja osmišljena su da nadvladaju vaše izazove i pomognu vašem poslovanju da napreduje na tržištu koje se stalno razvija.</p>",
					],
					en: [
						"<p>At Factory X, we specialize in creating custom software solutions for industries such as education, finance, medicine, recruiting, and beyond. Our focus is on building long-term partnerships and delivering tailored solutions that drive success.</p>",
						"<p>From consultation and requirements gathering to design, development, and support, we take care of it all. Our innovative, secure, and scalable solutions are crafted to overcome your challenges and help your business thrive in an ever-evolving market.</p>",
					],
				},
				// extraStyle: {
				// 	maxWidth: "85%"
				// }
			},
			{
				name: "FranzNET",
				url: "https://franz-net.hr/",
				logo: "franz-net-white-orange.svg",
				tags: {
					"hr": ["internet", "IT podrška", "ključ u ruke"],
					"en": ["Internet", "IT support", "turn-key solutions"],
				},
				description: {
					"hr": [
						"<p>FRANZ NET d.o.o. je regionalni telekom i IT partner s fokusom na sjeverozapadnu Hrvatsku.</p>",
						"<p>Privatnim i poslovnim korisnicima pružamo pouzdanu povezivost, suvremena tehnološka rješenja i brzu lokalnu podršku.</p>",
						"<p>Naš cilj je tehnologiju učiniti dostupnom, učinkovitom i bliskom korisniku, uz rješenja po principu „ključ u ruke” i podršku na koju se korisnici mogu osloniti.</p>",
					],
					"en": [
						"<p>FRANZ NET d.o.o. is a regional telecom and IT partner focused on northwestern Croatia.</p>",
						"<p>We provide both private and business users with reliable connectivity, modern technological solutions, and fast local support.</p>",
						"<p>Our goal is to make technology accessible, efficient, and close to the user, delivering turnkey solutions and support our customers can rely on.</p>",
					]
				}
			},
			{
				name: "HIWE-IT",
				url: "https://www.hiwe-it.com/",
				linkedIn: "https://www.linkedin.com/company/hiwe-it-sqs",
				logo: "hiwe-landscape.png",
				tags: ["Vue.js", "Quasar", "Node.js", "Java", "Spring", "SQL/NoSQL", "Graph Database", "IoT", "UI/UX", "Web & Mobile Development"],
				description: {
					hr: [
						"<p>U HIWE IT-u razvijamo napredna softverska rješenja koja pojednostavljuju složene poslovne procese i ubrzavaju digitalnu transformaciju tvrtki.</p>",
						"<p>Specijalizirani smo za web, mobilne i IoT sustave, s naglaskom na prilagođeni razvoj, UX/UI dizajn i pouzdanu tehničku podršku. .</p>",
						"<p>Naš cilj je stvoriti elegantna i učinkovita rješenja koja korisnicima donose stvarnu vrijednost..</p>"
					],
					en: [
						"<p>At HIWE IT, we develop advanced software solutions that simplify complex business processes and accelerate companies’ digital transformation.</p>",
						"<p>We specialize in web, mobile, and IoT systems, with a strong focus on custom development, UX/UI design, and reliable technical support.</p>",
						"<p>Our goal is to create elegant and efficient solutions that deliver real value to users.</p>"
					]
				},
			},
			{
				name: "IBM iX",
				url: "https://ibmix.de/en/croatia-ibm-ix/",
				linkedIn: "https://www.linkedin.com/company/ibm-ix-dach",
				logo: "IBM_iX_logotype_white_RGB.png",
				tags: [
					"C#", "Java", "JavaScript", "TypeScript", "CSS", "SCSS", "HTML", "AEM", "SAP", "Contentful", "Commercetools", "Workfront", "Angular", "React", "Next.js", "Vue.js", "SQL", "Spring", "Sling", "Git", "DevOps", "Docker", "Kubernetes", "Jenkins", "Kibana", "JUnit", "SonarQube", "Cypress", "Selenium", "Figma", "AI"
				],
				description: {
					"hr": [
						"<p>IBM iX jedan je od vodećih svjetskih pružatelja usluga digitalnog iskustva, koji kombinira savjetovanje, dizajn i tehnologiju kako bi isporučio cjelovitu digitalnu transformaciju. Kao dio IBM Consultinga, djeluje na sjecištu strategije, dizajna i tehnologije, pomažući organizacijama u stvaranju digitalnih iskustava usmjerenih na korisnika, u suradnji s partnerima poput Adobea, Salesforcea i SAP-a.</p>",
						"<p>U Hrvatskoj se IBM iX razvio u snažan Digital Excellence Hub od svojih početaka u Varaždinu 2015. godine, šireći se na urede u Zagrebu i Osijeku te gradeći multidisciplinarne timove koji obuhvaćaju razvoj, dizajn i poslovne uloge.</p>",
						"<p>Danas hrvatski timovi imaju ključnu ulogu unutar šire IBM iX mreže, radeći na međunarodnim projektima - osobito na DACH tržištu - dok istovremeno doprinose lokalnim znanjem, inovacijama i agilnim pristupom u isporuci kvalitetnih, korisnički orijentiranih digitalnih rješenja.</p>",

					],
					"en": [
						"<p>IBM iX is one of the world’s leading providers of digital experience services, combining consultancy, design, and technology to deliver end-to-end digital transformation. As part of IBM Consulting, it operates at the intersection of strategy, design, and technology, helping organizations create human-centered digital experiences in collaboration with partners like Adobe, Salesforce, and SAP.</p>",
						"<p>In Croatia, IBM iX has grown into a strong Digital Excellence Hub since its beginnings in Varaždin in 2015, expanding to offices in Zagreb and Osijek and building multidisciplinary teams across development, design, and business roles.</p>",
						"<p>Today, Croatian teams play a key role within the wider IBM iX network, working on international projects - especially across the DACH region - while contributing local expertise, innovation, and agile collaboration to deliver impactful, user-centered digital solutions.</p>"
					],
				},
				extraStyle: {
					maxWidth: "90%"
				}
			},
			{
				name: "Identyum",
				url: "https://identyum.com/",
				linkedIn: "https://www.linkedin.com/company/identyum/",
				logo: "Identyum logo clipped.svg",
				tags: {
					"hr": [
						"RegTech", "FinTech", "verifikacija identiteta", "KYC", "digitalni onboarding", "elektroničko potpisivanje", "provjera financijskih podataka", "digitalni ID novčanik"
					],
					"en": [
						"RegTech", "FinTech", "identity verification", "KYC", "digital onboarding", "electronic signing", "financial data verification", "digital ID wallet"

					]
				},
				description: {
					"hr": [
						"<p>Identyum je sveobuhvatna platforma za digitalni identitet koja pomaže poslovnim subjektima i pojedincima da sigurno verificiraju identitet, elektronički potpisuju dokumente i dijele podatke s punim povjerenjem.</p>",
						"<p>Platforma objedinjuje digitalni ID novčanik, verifikaciju identiteta, elektroničko potpisivanje i servis financijske provjere korisnika u sklopu jednog integriranog rješenja.</p>",
						"<p>Omogućuje potpuni online onboarding korisnika, usklađenost s KYC/AML regulativom i brže sklapanje ugovora, čime se povećava stopa konverzije i poslovna učinkovitost.</p>"
					],
					"en": [
						"<p>Identyum is a comprehensive digital identity platform that enables businesses and individuals to securely verify identities, electronically sign documents, and share data with full confidence.</p>",
						"<p>The platform combines a digital ID wallet, identity verification, electronic signing, and financial background checks into a single integrated solution.</p>",
						"<p>It enables fully online user onboarding, ensures compliance with KYC/AML regulations, and accelerates contract signing,  ultimately increasing conversion rates and operational efficiency.</p>"
					],
				}
			},
			{
				name: "Porobija & Špoljarić",
				logo: "psod_logo_transparent.png",
				url: "https://www.psod.hr/",
				linkedIn: "https://www.linkedin.com/company/porobija-&-%C5%A1poljari%C4%87-llc-",
				tags: {
					hr: [
						"AI", "ICT/TMT", "SaaS", "ITugovori", "GDPR", "digitalnoposlovanje", "compliance", "intelektualno vlasništvo"
					],
					en: [
						"AI", "ICT/TMT", "SaaS", "ITContracts", "GDPR", "digitalbusiness", "compliance", "intellectual property"
					]
				},
				description: {
					hr: [
						"<p>Odvjetničko društvo Porobija i Špoljarić d.o.o. pruža pravnu podršku klijentima iz tehnološkog sektora, s posebnim fokusom na ICT/TMT, ugovorne odnose i regulatorna pitanja digitalnog poslovanja.</p>",
						"<p>Pratimo društva u razvoju, lansiranju i širenju digitalnih proizvoda i usluga, savjetujući ih u području usklađenosti, umjetne inteligencije, zaštite podataka i intelektualnog vlasništva.</p>",
						"<p>Naš je cilj pružiti pravna rješenja koja su istovremeno stručno utemeljena, poslovno relevantna i primjenjiva ubrzom i stalno promjenjivom digitalnom okruženju.</p>"
					],
					en: [
						"<p>Law firm Porobija i Špoljarić d.o.o. provides legal support to clients from the technology sector, with a special focus on ICT/TMT, contractual relations and regulatory issues of digital business.</p>",
						"<p>We accompany companies in the development, launch and expansion of digital products and services, advising them in the areas of compliance, artificial intelligence, data protection and intellectual property.</p>",
						"<p>Our goal is to provide legal solutions that are at the same time professionally based, business relevant and applicable in a fast and constantly changing digital environment.</p>"
					]
				}
			},
			{
				name: "Prime Force",
				url: "https://prime-force.com/",
				linkedIn: "https://www.linkedin.com/company/prime-force-group",
				logo: "pf_logo_with_claim_white.svg",
				tags: [
					"Experience Management", "Marketing Automation", "Data-driven business models", "Analytics/BI/SEO", "Content Services Platforms", "Digitalization of processes", "Strategizing for Cloud Solutions", "Providing Managed services", "Java", "Sling", "JCR", "OSGi", "AEM", "Adobe"
				],
				description: {
					"hr": [
						"<p>Mi smo iskusni PRUŽATELJI CJELOVITE USLUGE s dugogodišnjim iskustvom!</p>",
						"<p>Našim klijentima diljem Europe pomažemo u digitalnoj transformaciji i suočavanju s izazovima kao što su:",
						"<ul class='specBoxList'>",
						"<li>Upravljanje korisničkim iskustvom i digitalno korisničko putovanje</li>",
						"<li>Marketing automatizacija i upravljanje angažmanom korisnika</li>",
						"<li>Analitika / BI i poslovni modeli temeljeni na podacima</li>",
						"<li>E-trgovina</li>",
						"<li>Upravljanje sadržajem na razini poduzeća i digitalizacija procesa</li>",
						"<li>Upravljanje web sadržajem (CMS) i SEO</li>",
						"<li>eDiscovery, praćenje usklađenosti i analiza</li>",
						"<li>Razvoj mobilnih aplikacija</li>",
						"<li>Cloud strategija i upravljane usluge (7x24 rad/podrška)</li>",
						"</ul></p>"
					],
					"en": [
						"<p>We are a super experienced FULL-SERVICE PROVIDER!</p>",
						"<p>We support our customers across Europe in the digital transformation and challenges like:",
						"<ul class='specBoxList'>",
						"<li>Experience management, digital customer journey</li>",
						"<li>Marketing Automation & Engagement Management</li>",
						"<li>Analytics / BI & data-driven business models</li>",
						"<li>e-Commerce</li>",
						"<li>Enterprise content management, digitization of processes</li>",
						"<li>Web Content Management (CMS), SEO</li>",
						"<li>eDiscovery, compliance monitoring and analysis</li>",
						"<li>Mobile app development</li>",
						"<li>Cloud strategy & managed services (7x24 operation / support)</li>",
						"</ul></p>"
					],
				}
			},
			{
				name: "Try it with ANN",
				url: "https://tryitwithann.com/",
				linkedIn: "https://www.linkedin.com/in/marijnhuizendveld/",
				logo: "ann - logo - white - rgb.svg",
				tags: ["model", "implementation", "proofofconcept", "domaindrivendesign", "ddd"],
				description: {
					"hr": [
						"<p>Jeste li se ikad osjećali kao da put od ideje do stvarne implementacije u kodu traje predugo? Čak i AI-generirani proof of concepti brzo mogu postati teško održivi.</p>",
						"<p>Upoznajte ANN - softversku aplikaciju potpuno kompatibilnu s Mirom, osmišljenu da vodi vas i vaš tim kroz proces razvoja. ANN olakšava održavanje Domain-Driven Designa (DDD), čini ga bržim i znatno konzistentnijim kroz cijelu organizaciju. Pomaže vam pisati bolje testove koji omogućuju AI-u da implementira rješenja koja su inženjerima dugoročno održiva.</p>",
						"<p>S ANN-om smanjujete vrijeme od ideje → modela → implementacije, a istovremeno dizajnirate sustave koji se neće urušiti pod vlastitim uspjehom.</p>",
						"<p>Sve to nije moguće samo zahvaljujući DDD-u, već zato što vas ANN drži na pravom putu, potiče eksperimentiranje i omogućuje bolju suradnju između product i development timova.</p>",
						"<p>Imate novu ideju? Samo je isprobajte.</p>",
						"<p>Isprobajte je uz ANN.</p>",
					],
					"en": [
						"<p>Ever felt it takes too long to go from idea to the actual implementation in code? Even AI-generated proof of concepts can quickly become unmanageable.</p>",
						"<p>Meet ANN. A software application fully compatible with Miro, designed to guide you and your team. It makes maintaining DDD easier, faster, and far more consistent across the entire organisation. Ann helps you write better tests that make it easy for AI to implement solutions that engineers are happy to maintain.</p>",
						"<p>With ANN, you will reduce the time from idea → model → implementation, and you will design systems Ann that won’t collapse under their own weight of success. All of this is possible not just thanks to DDD, but because ANN keeps you on track, encourages experimentation, and helps product and development teams collaborate better than ever.</p>",
						"<p>Got a new idea? Just try it.</p>",
						"<p>Try it with ANN.</p>"
					],
				},
				extraStyle: {
					maxWidth: "85%"
				}
			}
		],
		l4: null,
		l3: null,
		l2: null,
		l1: null
	},
	exhibitors: [],
	partners: {},
	mediaPartners: [
		{
			name: ".debug",
			logo: "debug2025-logo-pozitiv.png",
			url: "https://www.debug.hr/",
			linkedIn: "https://www.linkedin.com/company/debughr/",
			tags: [
				"conference", "technology", "development", "design", "AI", "cybersecurity", "tech trends", "IT community"
			],
			description: {
				hr: [
					".debug je vodeća tehnološka konferencija i središnje okupljalište tehnološke zajednice u Hrvatskoj. U organizaciji Buga i njegovih strateških partnera, predstavlja najveći nacionalni tehnološki događaj, posvećen poticanju razmjene znanja, profesionalnog umrežavanja i rasta regionalnog IT ekosustava. Zamišljena kao impresivan tehnološki izlog, godišnja dvodnevna konferencija u Zagrebu okuplja više od 2000 IT stručnjaka. Program sadrži odabrani izbor od više od 100 prezentacija koje predvode stručnjaci u nekoliko smjerova. Događaj se ističe svojom jedinstvenom atmosferom, spajanjem tehničke edukacije na visokoj razini s ekspanzivnim prostorom za umrežavanje, koji polaznicima pruža platformu za izravnu suradnju s predstavnicima vrhunskih tehnoloških tvrtki u opuštenom okruženju inspiriranom festivalom."
				],
				en: [
					".debug is the leading technology conference and the central gathering point for the tech community in Croatia. Organized by Bug and its strategic partners, it stands as the nation’s largest technological event, dedicated to fostering knowledge exchange, professional networking, and the growth of the regional IT ecosystem. Conceived as an immersive technological showcase, the annual two-day conference in Zagreb brings together over 2,000 IT professionals. The program features a curated selection of more than 100 expert-led presentations delivered across several tracks. The event is distinguished by its unique atmosphere, blending high-level technical education with an expansive outdoor networking area, which provides a platform for attendees to engage directly with representatives from top-tier technology companies in a relaxed, festival-inspired environment."
				],
			},
			extraStyle: {
			}
		},
	],
	survey: {
		options: {
			combinedEvents: ["weblica", "worklica"] // if defined, survey will show combined title + combined sessions (separated into section with event name)
		},
		// generic survey questions (used only if event specific are not defined)
		visitors: [
			{
				// OK
				required: true,
				question: {
					hr: "Koliko ste općenito zadovoljni događajem?",
					en: "How satisfied were you with the event in general?",
				},
				stars: true,
				comment_opt: true
			},
			{
				// OK
				required: true,
				question: {
					hr: "Koliko ste zadovoljni ukupnom kvalitetom predavanja?",
					en: "How satisfied are you with the general quality of the sessions?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koje je bilo Vaše najdraže iskustvo ili trenutak događaja?",
					en: "What was your favorite experience or moment of the event?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Što bismo mogli poboljšati?",
					en: "What could we improve on?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Da li je događaj ispunio vaša očekivanja?",
					en: "Did the event meet your expectations?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Kolika je vjerojatnost da ćete u budućnosti posjećivati ​​naše događaje?",
					en: "How likely would you be to attend our events in the future?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Biste li naše događaje preporučili prijatelju ili kolegi?",
					en: "Would you recommend our events to a friend or colleague?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Jeste li imali priliku i mjesto za postavljanje pitanja i sudjelovanje?",
					en: "Did you have an opportunity and place to ask questions and participate?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koliko ste bili zadovoljni pruženim mogućnostima umrežavanja?",
					en: "How satisfied were you with the networking opportunities provided?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Kako ste saznali za ovaj događaj?",
					en: "How did you hear about this event?",
				},
				options: {
					type: "checkbox",
					items: [
						{
							value: "colleague-friend",
							text: {
								hr: "Kolega/Prijatelj/Poznanik",
								en: "Colleague/Friend/Acquaintance",
							},
						},
						{
							value: "social-network",
							text: {
								hr: "Društvene mreže",
								en: "Social network",
							},
						},
						{
							value: "portal",
							text: {
								hr: "IT portal",
								en: "IT portal",
							},
						},
						{
							value: "newsletter",
							text: {
								hr: "Newsletter",
								en: "Newsletter",
							},
						},
						{
							value: "poster",
							text: {
								hr: "Plakat",
								en: "Poster",
							},
						},
						{
							value: "other",
							text: {
								hr: "Neki drugi način ...",
								en: "Some other way ...",
							},
						},
					],
				},
				comment_opt: true,
				comment_placeholder: {
					hr: "Ako ste saznali na neki drugi način, molimo da ovdje napišete kako?",
					en: "If you heard about this event in another way, please tell us how?",
				},
			},
			{
				// OK
				question: {
					hr: "Jeste li već bili na ovom događaju?",
					en: "Have you attended this event before?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koliko Vam je osoblje bilo od pomoći?",
					en: "How helpful was the staff at the event?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koliko je platforma za događaj bila jednostavna za navigaciju?",
					en: "How easy-to-navigate was the platform for the event?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK - ADDED
				question: {
					hr: "Da li su oznake u i oko prostora bile dostatne za snalaženje?",
					en: "Were the markings in and around the event area sufficient for navigation?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koje biste teme voljeli vidjeti više na budućim događanjima?",
					en: "What topics would you want to see more of at future events?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Molimo podijelite sve dodatne komentare, misli, prijedloge za buduće događaje.",
					en: "Please share any additional comments, thoughts, suggestions for future events.",
				},
				comment: true,
			},
		],
		speakers: [
			{
				// OK
				required: true,
				question: {
					hr: "Koliko ste općenito zadovoljni događajem?",
					en: "How satisfied were you with the event in general?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Koje je bilo Vaše najdraže iskustvo ili trenutak događaja?",
					en: "What was your favorite experience or moment of the event?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Gdje ste saznali da se možete prijaviti kao predavač na našoj konferenciji?",
					en: "Where did you find out that you can register as a lecturer at our conference?",
				},
				comment: true,
			},
			{
				// OK
				question: {
					hr: "Jesu li tehnička podrška i oprema zadovoljili vaše potrebe tijekom predavanja?",
					en: "Did the technical support and equipment meet your needs during the presentation?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Kako ocjenjujete organizaciju i komunikaciju s organizacijskim timom prije i tijekom konferencije?",
					en: "How do you rate the organization and communication with the organizing team before and during the conference?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Kako biste ocijenili interes i angažman publike tijekom vašeg predavanja?",
					en: "How would you assess the interest and engagement of the audience during your presentation?",
				},
				stars: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Jesu li vam pružene dovoljne prilike za networking i interakciju s ostalim predavačima i sudionicima?",
					en: "Were you provided with sufficient opportunities for networking and interaction with other speakers and participants?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Postoji li nešto što bi moglo biti poboljšano u vezi s vašim iskustvom na konferenciji?",
					en: "Is there anything that could be improved in relation to your experience at the conference?",
				},
				comment: true,
			},
			{
				// OK
				// required: true,
				question: {
					hr: "Biste li se željeli vratiti kao predavač na budućim izdanjima naše konferencije?",
					en: "Would you like to return as a speaker at future editions of our conference?",
				},
				boolean: true,
				comment_opt: true,
			},
			{
				// OK
				question: {
					hr: "Imate li preporuke za teme ili sadržaje koji bi mogli obogatiti buduća izdanja naše konferencije?",
					en: "Do you have any recommendations for topics or content that could enrich future editions of our conference?",
				},
				comment: true,
			},
		],
	},
}
